@if (loadingFollowUp || loadingBilling || loadingFeedback || loadingReminders || loadingHandover ||
loadingQuestionnaire) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" style="width: 100px;" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
}
<div class="page-bg" [hidden]="navbar.userAccess?.Appointments!='Full' && navbar.userAccess?.Appointments!='Readonly'">
	<div class="card">
		<div class="card-body p-1">
			<mat-accordion [hideToggle]="false">
				<mat-expansion-panel [expanded]="false" #mat_expansion_panel>
					<mat-expansion-panel-header class="bg-theme modern-panel-header">
						<mat-panel-title class="modern-panel-title">
							<div class="case-header-wrapper">

								<!-- Section 1: Navigation & Info -->
								<div class="header-section-info">

									<!-- Back & Status -->
									<div class="nav-status-group">
										<a class="modern-icon-btn back-btn" [routerLink]="['/app/list-appointment']"
											matTooltip="Back to Home">
											<fa-icon [icon]="['fas','sign-out-alt']" [flip]="'horizontal'"></fa-icon>
										</a>

										<div class="modern-status-badge" [class.locked]="caseDetails.status == 2"
											matTooltip="{{ caseDetails?.case_status }}">
											<fa-icon
												[icon]="['fas', caseDetails.status==2 ? 'lock' : 'lock-open']"></fa-icon>
										</div>
									</div>

									<!-- Divider -->
									<div class="vertical-divider"></div>

									<!-- Info Chips -->
									<div class="modern-info-chips">
										<div class="chip">
											<span class="chip-label">Case ID</span>
											<span class="chip-value">{{ caseDetails.case_id }}</span>
										</div>
										<div class="chip">
											<span class="chip-label">Start Date</span>
											<span class="chip-value">{{ caseDetails?.start_date }}</span>
										</div>
										<div class="chip patient-chip">
											<span class="chip-label">Patient</span>
											<span class="chip-value">{{ caseDetails?.f_name }} {{ caseDetails?.l_name
												}}</span>
										</div>
										<div class="chip">
											<span class="chip-label">Vessel</span>
											<span class="chip-value">{{ caseDetails.vessel || '—' }}</span>
										</div>
										<div class="chip">
											<span class="chip-label">Company</span>
											<span class="chip-value">{{ caseDetails?.company?.name || '—' }}</span>
										</div>
									</div>
								</div>

								<!-- Section 2: Actions & Toggles -->
								<div class="header-section-controls">

									<!-- Quick Actions -->
									<div class="modern-action-btns">
										@if (navbar.userAccess?.Invoice=='Full' ||
										navbar.userAccess?.Invoice=='Readonly') {
										<a class="action-btn invoice" matTooltip="Invoice"
											[routerLink]="['/app/case-invoice',uId]">
											<fa-icon [icon]="['fas','rupee-sign']"></fa-icon>
										</a>
										}
										@if (navbar.userAccess?.Closure_Report=='Full' ||
										navbar.userAccess?.Closure_Report=='Readonly') {
										<a class="action-btn closure" matTooltip="Closure Report"
											[routerLink]="['/app/closure-report',uId]">
											<fa-icon [icon]="['fas','file-pdf']"></fa-icon>
										</a>
										}
										<a class="action-btn prescription" matTooltip="Prescription"
											[routerLink]="['/app/prescription',uId]">
											<fa-icon [icon]="['fas','medkit']"></fa-icon>
										</a>
										@if (navbar.userAccess?.Follow_up=='Full') {
										<button class="action-btn telecon" (click)="createTeleConFUs($event)"
											matTooltip="Create Tele-Consult follow-up">
											@if(showTeleConLoader){
											<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
											}@else {
											<img src="../../assets/img/appt-types/{{appt_type_images['Tele-Consult/Second Opinion']}}"
												class="telecon-btn-img" alt="Telecon" />
											}
										</button>
										}
									</div>

									<!-- Divider -->
									<div class="vertical-divider hidden-mobile"></div>

									<!-- Toggles -->
									<div class="modern-toggles">
										<label class="ui-switch-wrapper">
											<span class="switch-label">Mark for closure</span>
											<div class="ui-switch">
												<input type="checkbox" id="checkMarkForClosure"
													[(ngModel)]="mark_for_closure" (change)="markForClosureChange()"
													[disabled]="navbar.userAccess?.Appointments != 'Full'" />
												<span class="slider"></span>
											</div>
											<fa-icon *ngIf="mark_loader" [icon]="['fas','spinner']" [animation]="'spin'"
												class="loader-icon"></fa-icon>
										</label>

										<label class="ui-switch-wrapper">
											<span class="switch-label">Ready to bill</span>
											<div class="ui-switch">
												<input type="checkbox" id="checkReadyToBill" [(ngModel)]="ready_to_bill"
													(change)="readyToBillChange()"
													[disabled]="navbar.userAccess?.Appointments != 'Full'" />
												<span class="slider"></span>
											</div>
											<fa-icon *ngIf="ready_to_bill_loader" [icon]="['fas','spinner']"
												[animation]="'spin'" class="loader-icon"></fa-icon>
										</label>
									</div>
									<!-- Divider -->
									<!-- <div class="vertical-divider hidden-mobile"></div> -->
								</div>
							</div>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<!-- Cand:<input [(ngModel)]="candidateUserName" /><br />
					Doc:<input [(ngModel)]="userName" /> -->
					<div class="row g-1 mt-2">
						<div class="col ps-1">
							<div class="card overflow-x-hidden crew-details-height">
								<div class="card-header p-1 mb-0 bg-theme-1">
									<h5 class="card-title text-dark text-center mb-0">
										Crew Details
										@if (navbar.userAccess?.Appointments == 'Full') {
										<a class="float-end text-dark" matTooltip="Edit"
											[routerLink]="['/app/edit-case',uId]">
											<fa-icon [icon]="['fas','edit']"></fa-icon>
										</a>
										}
									</h5>
								</div>
								<div class="card-body overflow-y-auto">
									<table class="table">
										<tbody>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Name
														</div>
														<div class="col-md-8">
															<strong>
																{{ caseDetails?.f_name }}
																&nbsp;
																{{ caseDetails?.l_name }}
															</strong>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Crew-Id
														</div>
														<div class="col-md-8">
															<strong>
																{{caseDetails?.crew_id || "___"}}
															</strong>
															<!-- <fa-icon [icon]="['fas','edit']" class="float-end" matTooltip="Edit"
														(click)="openCrewIdModal()" role="button"></fa-icon> -->
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Rank
														</div>
														<div class="col-md-8">
															<strong>
																{{ caseDetails?.rank_name || "___" }}
															</strong>
															<!-- <fa-icon [icon]="['fas','edit']" class="float-end" matTooltip="Edit"
														(click)="openRankModal()" role="button"></fa-icon> -->
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Date of Birth
														</div>
														<div class="col-md-8">
															<strong>
																{{caseDetails?.dob || "___"}}
															</strong>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Telephone No.
														</div>
														<div class="col-md-8">
															<strong>
																{{caseDetails?.country_code}}
																&nbsp;
																{{caseDetails?.tel_no || '___'}}
															</strong>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Email-Id
														</div>
														<div class="col-md-8">
															<strong>
																{{caseDetails?.email || '___'}}
															</strong>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-4">
															Address
														</div>
														<div class="col-md-8">
															<strong>
																{{caseDetails?.address || '___'}}
															</strong>
															<!-- <fa-icon [icon]="['fas','edit']" class="float-end" matTooltip="Edit"
														(click)="openAddressModal()" role="button"></fa-icon> -->
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="card overflow-x-hidden" *ngIf="caseDetails.status == 2">
								<div class="card-header p-1 mb-0 bg-theme-1">
									<h5 class="card-title text-dark text-center mb-0">
										Closure Details
									</h5>
								</div>
								<div class="card-body">
									<table class="table">
										<tbody>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-12">
															Closure Status:
														</div>
														<div class="col-md-12">
															<strong>
																{{
																caseDetails?.status4_name ||
																"___"
																}}
															</strong>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-1">
														<div class="col-md-12">
															Closure Notes:
														</div>
														<div class="col-md-12">
															<span [innerHTML]="caseDetails?.closure_notes||'___'">
															</span>
														</div>
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="col px-1">
							<div class="card overflow-x-hidden key-eval-height">
								<div class="card-header p-1 mb-0 bg-theme-1">
									<h5 class="card-title text-dark text-center mb-0">
										Key Evaluations
										<strong class="text-danger" *ngIf="isKeyEvalIncomplete()">
											(Incomplete)
										</strong>
										@if (navbar.userAccess?.Appointments == 'Full'){
										<fa-icon [icon]="['fas', 'edit']" class="float-end" role="button"
											matTooltip="Edit" (click)="keyEvalModal()">
										</fa-icon>
										}
									</h5>
								</div>
								<div class="card-body overflow-y-auto">
									<table class="table">
										<tbody>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Hospitalized</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.hospitalization_status ||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Hospitalization Date</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.admission_date ||
																"___"
																}}
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Surgery Required</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.surgery_status ||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Surgery Date</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.actual_surgery_date ||
																"___"
																}}
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>Any Disability</label>
															</p>
															<div class="col-sm-12 ps-1">
																<!-- {{
																caseDetails?.other_details?.disability_status ||
																"___"
																}} -->
																{{
																caseDetails?.disability ||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Disability %</label>
															</p>
															<div class="col-sm-12 ps-1">
																<!-- {{
																caseDetails?.other_details?.disability_per ||
																"___"
																}} -->
																{{
																caseDetails?.disability_per ||
																"___"
																}}
															</div>
														</div>
													</div>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	Disability Notes
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View"
																		(click)="showDisabilityModal()">
																	</fa-icon>
																</label>
															</p>
															<!-- <div class="col-sm-12 ps-1">
																{{caseDetails?.disability_notes || "___"}}
															</div> -->
														</div>
													</div>
												</td>
											</tr>
											<!-- <tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	Hospitalization
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View" (click)="showHospModal()">
																	</fa-icon>
																</label>
															</p>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>
																	Surgery
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View" (click)="showSurgModal()">
																	</fa-icon>
																</label>
															</p>
														</div>
													</div>
												</td>
											</tr> -->
											<!-- <tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	Disability
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View"
																		(click)="showDisabilityModal()">
																	</fa-icon>
																</label>
															</p>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>
																	Physiotherapy
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View" (click)="showPhysioModal()">
																	</fa-icon>
																</label>
															</p>
														</div>
													</div>
												</td>
											</tr> -->
											<tr>
												<td>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>PT Sessions</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.physiotherapy_session_counts
																||
																"___"
																}}
															</div>
														</div>
														<div class="col">
															<p class="mb-0">
																<label>Imp. %</label>
															</p>
															<div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.physiotherapy_percentage ||
																"___"
																}}
															</div>
														</div>
													</div>
													<div class="row g-0">
														<div class="col">
															<p class="mb-0">
																<label>
																	PT Notes
																	<fa-icon [icon]="['fas','info']" role="button"
																		matTooltip="View" (click)="showPhysioModal()">
																	</fa-icon>
																</label>
															</p>
															<!-- <div class="col-sm-12 ps-1">
																{{
																caseDetails?.other_details?.physiotherapy_notes ||
																"___"
																}}
															</div> -->
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Expected Closure Date
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.expected_closure_date_display || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															ICD Code
															<!-- <fa-icon [icon]="['fas','info']" role="button"
																matTooltip="View"
																(click)="showInModal('ICD Code',caseDetails?.icd_code)">
															</fa-icon> -->
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.icd_code || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Diagnosis
															<!-- <fa-icon [icon]="['fas','info']" role="button"
																matTooltip="View"
																(click)="showInModal('Diagnosis',caseDetails?.diagnosis)">
															</fa-icon> -->
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.diagnosis || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Due To
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.due_to || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Medical History
															@if (navbar.userAccess?.Appointments == 'Full'){
															<fa-icon [icon]="['fas','edit']" role="button"
																(click)="openMedHistoryModal()"></fa-icon>
															}
															<!-- <fa-icon [icon]="['fas','info']" role="button"
																matTooltip="View"
																(click)="showInModal('Medical History',caseDetails?.medical_history)">
															</fa-icon> -->
														</label>
													</p>
													<div class="col-sm-12 pl-xl">
														<span *ngIf="caseDetails?.medical_history"
															[innerHTML]="caseDetails?.medical_history | safeHtml"></span>
														<span *ngIf="!caseDetails?.medical_history">
															___
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Work related
														</label>
													</p>
													<div class="col-sm-12 pl-xl">
														{{caseDetails?.work_related?"Yes":"___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Date of Arrival
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.arrival_date_display || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Fitness Date
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.fitness_date_display || "___"}}
													</div>
												</td>
											</tr>
											<tr>
												<td>
													<p class="mb-0">
														<label>
															Expected Treatment Cost
														</label>
													</p>
													<div class="col-sm-12 ps-1">
														{{caseDetails?.expected_treatment_cost || "___"}}
													</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="col px-1">
							<div class="card overflow-x-hidden onboard-details-height">
								<div class="card-header p-1 mb-0 bg-theme-3">
									<h5 class="card-title text-dark text-center mb-0">
										Reminders
									</h5>
								</div>
								<div class="card-body overflow-y-auto">
									<ng-container *ngIf="caseReminder">
										<ul class="text-reminder">
											<li *ngIf="caseReminder.crew_details_not_filled">
												<h5 class="mb-0">
													Please fill crew details.
												</h5>
											</li>
											<li *ngIf="caseReminder.data_not_filled">
												<h5 class="mb-0">
													Please fill key evaluations.
												</h5>
											</li>
											<li *ngIf="caseReminder.mark_for_closure">
												<h5 class="mb-0">
													Case is marked for closure but not closed.
												</h5>
											</li>
											<li *ngIf="caseReminder.incomplete_billing.length">
												<h5 class="mb-0">
													Billing is incomplete in following follow-ups:
												</h5>
												<ul>
													@for (followup of caseReminder.incomplete_billing;
													track
													$index) {
													<li>
														<h5 class="mb-0">
															<a (click)="follFromReminder(followup.followup_encid)"
																role="button">
																{{followup.date}}
															</a>
														</h5>
													</li>
													}
												</ul>
											</li>
											<li *ngIf="caseReminder.files_not_uploaded.length">
												<h5 class="mb-0">
													File are missing in following follow-ups:
												</h5>
												<ul>
													@for (followup of caseReminder.files_not_uploaded;
													track
													$index) {
													<li>
														<h5 class="mb-0">
															<a (click)="follFromReminder(followup.followup_encid)"
																role="button">
																{{followup.date}}
															</a>
														</h5>
													</li>
													}
												</ul>
											</li>
										</ul>
									</ng-container>
								</div>
							</div>
						</div>
						<div class="col pe-1">
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card" [ngClass]="getClass(caseDetails?.case_days)">
										<p class="data-card-value fw-bold">
											{{ caseDetails?.case_days || "___" }}
										</p>
										<p class="data-card-label">
											Case Days Open
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card text-light"
										[ngClass]="'bg-'+getTriage(caseDetails?.triage).color">
										<p class="data-card-value">
											<i class="bi bi-flag-fill">
											</i>
											{{
											getTriage(caseDetails?.triage).text
											}}
										</p>
										<p class="data-card-label">
											Triage Code
											@if (navbar.userAccess?.Appointments == 'Full'){
											<fa-icon [icon]="['fas','edit']" role="button" (click)="openTriageModal()">
											</fa-icon>
											}
										</p>
									</div>
								</div>
							</div>
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{ caseDetails?.case_category || "___" }}
										</p>
										<p class="data-card-label">
											Case Category
											@if (navbar.userAccess?.Appointments == 'Full'){
											<fa-icon [icon]="['fas','edit']" matTooltip="Edit" role="button"
												(click)="openCaseCatModal()"></fa-icon>
											}
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{
											caseDetails?.assigned_sc_agent?.name ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											SC Doctor
											@if (navbar.userAccess?.Appointments == 'Full'){
											<fa-icon [icon]="['fas','edit']" role="button"
												(click)="openAssigneeModal()"></fa-icon>
											}
										</p>
									</div>
								</div>
							</div>
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{
											caseDetails?.bill_details?.status ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											Billed Status
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{ caseDetails?.bill_details?.date || "___" }}
										</p>
										<p class="data-card-label">
											Billed Date
										</p>
									</div>
								</div>
							</div>
							<div class="row g-1">
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											{{
											caseDetails?.other_details?.last_report ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											Last Report
										</p>
									</div>
								</div>
								<div class="col text-center">
									<div class="card p-1 data-card bg-theme">
										<p class="data-card-value">
											<fa-icon [icon]="['fas','rupee-sign']"></fa-icon>
											{{
											caseDetails?.total_cost ||
											"___"
											}}
										</p>
										<p class="data-card-label">
											Total Bill
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</mat-accordion>
			<div class="card mt-1">
				<div class="card-body p-1">
					<div class="row g-1">
						<div class="col-lg-12 ps-1">
							<div class="row g-1">
								<div class="col-lg-12">
									<ul class="nav nav-tabs nav-tabs-bordered mb-2" role="tablist">
										<li class="nav-item" role="button" (click)="setActiveTab(0)">
											<a class="nav-link" [ngClass]="getTabClass(0)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Questionnaire
											</a>
										</li>
										@if (
										navbar.userAccess?.Follow_up=='Full' ||
										navbar.userAccess?.Follow_up=='Readonly'
										) {
										<li class="nav-item" role="button" (click)="setActiveTab(1)">
											<a class="nav-link" [ngClass]="getTabClass(1)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Follow-up
											</a>
										</li>
										}
										@if (
										navbar.userAccess?.Billing=='Full' ||
										navbar.userAccess?.Billing=='Readonly'
										) {
										<li class="nav-item" role="button" (click)="setActiveTab(2)">
											<a class="nav-link" [ngClass]="getTabClass(2)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Billing
											</a>
										</li>
										}
										<li class="nav-item" role="button" (click)="setActiveTab(3)">
											<a class="nav-link" [ngClass]="getTabClass(3)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Feedback
											</a>
										</li>
										@if (
										navbar.userAccess?.Follow_up=='Full' ||
										navbar.userAccess?.Follow_up=='Readonly'
										) {
										<li class="nav-item" role="button" (click)="setActiveTab(4)">
											<a class="nav-link" [ngClass]="getTabClass(4)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Non-Medical/Handover
											</a>
										</li>
										}
										@if (
										navbar.userAccess?.Mailbox=='Full' ||
										navbar.userAccess?.Mailbox=='Readonly'
										) {
										<li class="nav-item" role="button" (click)="setActiveTab(5)">
											<a class="nav-link" [ngClass]="getTabClass(5)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Mailbox
											</a>
										</li>
										}
										<li class="nav-item" role="button" (click)="setActiveTab(6)">
											<a class="nav-link" [ngClass]="getTabClass(6)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Case Notes
											</a>
										</li>
										<li class="nav-item" role="button" (click)="setActiveTab(7)">
											<a class="nav-link" [ngClass]="getTabClass(7)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Files
											</a>
										</li>
										@if (
										navbar.userAccess?.Call_Recordings=='Full' ||
										navbar.userAccess?.Call_Recordings=='Readonly'
										) {
										<li class="nav-item" role="button" (click)="setActiveTab(8)">
											<a class="nav-link" [ngClass]="getTabClass(8)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Call Recordings
											</a>
										</li>
										}
										<li class="nav-item" role="button" (click)="setActiveTab(9)">
											<a class="nav-link" [ngClass]="getTabClass(9)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Administrative Notes
											</a>
										</li>
										<li class="nav-item" role="button" (click)="setActiveTab(10)">
											<a class="nav-link" [ngClass]="getTabClass(10)" data-bs-toggle="tab"
												role="tab" aria-controls="ex1-tabs-1" aria-selected="true">
												Onboard Case Details
											</a>
										</li>
									</ul>
									<div class="tab-content">
										<div [ngClass]="getTabPaneClass(0)">
											<div class="card">
												<div class="card-header">
													<h5 style="font-size: 12px !important;"
														class="card-title text-dark mb-0">
														Questionnaire
													</h5>
												</div>
												<div class="card-body p-1">
													@if (questionnaire.length) {
													@for (
													foll of questionnaire;
													track foll;
													let i = $index
													){
													@if(i == currentQueFollIndex){
													<table class="table table-bordered questions-table">
														<thead>
															<tr>
																<th>
																	Follow-up Date: {{reverseDate(foll.followup_date)}}
																</th>
															</tr>
														</thead>
														<tbody>
															@for (
															que of foll.questions;
															track que;
															let j = $index
															) {
															<tr>
																<td>
																	<p class="mb-0 text-dark">
																		{{j + 1}}.
																		{{que.question}}
																		<fa-icon [icon]="['fas','times']"
																			class="text-danger float-end" role="button"
																			matTooltip="Remove"
																			(click)="removeQuestion(i,j)">
																		</fa-icon>
																	</p>
																	<mat-radio-group [(ngModel)]="que.answer">
																		@for (a of que.options; track $index) {
																		<mat-radio-button [value]="a"
																			[color]="'primary'">
																			{{a}}
																		</mat-radio-button>
																		}
																	</mat-radio-group>
																</td>
															</tr>
															}
															<tr>
																<td>
																	<button type="button" class="btn btn-sm btn-success"
																		(click)="saveQuestions(i)">
																		@if(savingQuestionnaire === foll.id){
																		<fa-icon [icon]="['fas','spinner']"
																			[animation]="'spin'"></fa-icon>
																		}@else{
																		<fa-icon [icon]="['fas','save']"></fa-icon>
																		}
																		Save
																	</button>
																	@if(
																	(questionnaire.length - 1) > currentQueFollIndex
																	){
																	<button type="button"
																		class="btn btn-sm btn-primary float-end"
																		(click)="nextFollQue()">
																		Next
																		<fa-icon
																			[icon]="['fas','arrow-right']"></fa-icon>
																	</button>
																	}
																	@if(currentQueFollIndex){
																	<button type="button"
																		class="btn btn-sm btn-primary float-end me-1"
																		(click)="prevFollQue()">
																		<fa-icon
																			[icon]="['fas','arrow-left']"></fa-icon>
																		Previous
																	</button>
																	}
																</td>
															</tr>
														</tbody>
													</table>
													}
													}
													}@else {
													<h4 class="mb-0 ps-2">
														No Questions
													</h4>
													}
													@if (questionError) {
													<p class="text-danger">
														{{questionError}}
													</p>
													}
												</div>
											</div>
										</div>
										<div [ngClass]="getTabPaneClass(1)">
											<div class="row g-0">
												<div class="col-md-3 followUpListBox">
													@if (
													!loadingFollowUp && (navbar.userAccess?.Follow_up=='Full' ||
													navbar.userAccess?.Follow_up=='Readonly')
													) {
													@for( card of followupList; track $index){
													<div class="card followup-card mb-1"
														[routerLink]="[getFollowUpUrl(card.enc_id)]"
														[routerLinkActive]="'selected'" style="cursor: pointer">
														<!-- <div class="card followup-card mb-1" (click)="selectFollowUp(card.enc_id)"
														[ngClass]="card.enc_id == selectedFollowUpId?'selected':''"
														style="cursor: pointer"> -->
														<div class="card-body p-2">
															<div class="row g-0 text-uppercase">
																<div class="col">
																	<span class="badge bg-secondary text-light fw-bold">
																		{{ card?.follow_up_date }}
																	</span>
																	<img *ngIf="card?.visit_type"
																		src="../../assets/img/appt-types/{{appt_type_images[card?.visit_type?.name]}}"
																		class="appt-type-img ms-1"
																		[matTooltip]="card?.visit_type?.name" />
																</div>
																<div class="col text-end">
																	<span class="badge fw-bold text-dark"
																		[ngClass]="getFollowUpStatusClass(card.follow_up_status?.id)">
																		{{ card?.follow_up_status?.name }}
																	</span>
																	<fa-icon
																		*ngIf="followupList.length &gt; 1 && card.follow_up_status?.id==1 && navbar.userAccess?.Follow_up=='Full'"
																		[icon]="['fas','trash-alt']"
																		class="text-danger ms-1 fs-12"
																		(click)="deleteFollowUp(card.enc_id)"
																		matTooltip="Delete" role="button">
																	</fa-icon>
																</div>
															</div>
															<div class="row g-0 text-uppercase fw-bold mt-1">
																<div class="col hospital-name">
																	@if (card?.dropoff_hospital) {
																	<!-- <span class="badge bg-light text-dark">
																			{{
																			card?.dropoff_hospital?.name
																			}}
																		</span> -->
																	{{
																	card?.dropoff_hospital?.name
																	}}
																	}@else {
																	&nbsp;
																	}
																</div>
															</div>
															<!-- <div class="row g-0 text-uppercase fw-bold">
																	<div class="col">
																		<span *ngIf="card?.visit_type"
																			class="badge bg-info text-dark">
																			{{card?.visit_type?.name}}
																		</span>
																		<img *ngIf="card?.visit_type"
																			src="../../assets/img/appt-types/{{appt_type_images[card?.visit_type?.name]}}"
																			class="appt-type-img"
																			[matTooltip]="card?.visit_type?.name" />
																	</div>
																</div> -->
														</div>
													</div>
													}
													<div class="card followup-card mb-1" *ngIf="!followupList.length">
														<div class="card-body p-2">
															<div class="row g-0">
																<div class="col text-center">
																	<button class="btn btn-sm btn-success"
																		(click)="openNewFollowupModal()">
																		New Follow-up
																	</button>
																</div>
															</div>
														</div>
													</div>
													}
												</div>
												<!-- <div class="col-md-9" [@routeAnimations]="prepareRoute(o)">
													<router-outlet #o="outlet"></router-outlet>
												</div> -->
												<div class="col-md-9">
													@if(selectedFollowUpId && uId){
													<app-followup-details #followupDetailsComponent [uId]="uId"
														[followupId]="selectedFollowUpId">
													</app-followup-details>
													}
												</div>
											</div>
										</div>
										<div [ngClass]="getTabPaneClass(2)"
											*ngIf="navbar.userAccess?.Billing=='Full' || navbar.userAccess?.Billing=='Readonly'">
											<div class="row g-1">
												<div class="col-md-12">
													<div class="card" @fadeInOut *ngIf="!loadingBilling">
														<div class="card-header">
															<h5 class="card-title text-dark mb-0">
																Billing
																<fa-icon [icon]="['fas', 'edit']" class="float-end"
																	role="button" matTooltip="Edit"
																	(click)="openBillModal()"
																	*ngIf="navbar.userAccess?.Billing=='Full'">
																</fa-icon>
																<a [routerLink]="['/app/bill-files',uId]"
																	class="float-end me-4">
																	View Files
																</a>
															</h5>
														</div>
														<div class="card-body">
															<table class="table table-bordered less-padding">
																<thead>
																	<tr>
																		<th style="width: 5% !important;">Sr. No.</th>
																		<th style="width: 10% !important;">Date</th>
																		<th style="width: 10% !important;">Category</th>
																		<th style="width: 10% !important;">Notes</th>
																		<th style="width: 10% !important;">Amount</th>
																		<th style="width: 10% !important;">Files</th>
																		<th style="width: 10% !important;">QR Code</th>
																		<th style="width: 10% !important;">Gpay</th>
																		<th style="width: 6% !important;">Paid</th>
																		<th style="width: 7% !important;">Approval</th>
																		<th style="width: 6% !important;">Reimbursement
																		</th>
																		<th style="width: 6% !important;">Billed</th>
																	</tr>
																</thead>
																<tbody>
																	<ng-container
																		*ngFor="let bill of followUpBillsData;let i = index;">
																		<tr
																			[ngClass]="{ 'orange': !bill.files || bill.files.length==0 }">
																			<td>
																				{{ i+1 }}
																			</td>
																			<td>
																				{{bill.date}}
																			</td>
																			<td>
																				<!-- {{getBillCatName(bill.category)}} -->
																				{{bill.category_name}}
																			</td>
																			<td>
																				{{bill.notes}}
																			</td>
																			<td>
																				{{bill.amount}}
																			</td>
																			<td>
																				<ng-container *ngIf="bill.files">
																					<div *ngFor="let file of bill.files;let j = index;"
																						class="icon-container no-delete">
																						<file-icon
																							[file]="file"></file-icon>
																					</div>
																				</ng-container>
																			</td>
																			<td>
																				<ng-container *ngIf="bill.qrcode_files">
																					<div *ngFor="let file of bill.qrcode_files;let j = index;"
																						class="icon-container no-delete">
																						<file-icon
																							[file]="file"></file-icon>
																					</div>
																				</ng-container>
																			</td>
																			<td>
																				<ng-container *ngIf="bill.gpay_files">
																					<div *ngFor="let file of bill.gpay_files;let j = index;"
																						class="icon-container no-delete">
																						<file-icon
																							[file]="file"></file-icon>
																					</div>
																				</ng-container>
																			</td>
																			<td>
																				<fa-icon *ngIf="bill.is_paid"
																					[icon]="['fas', 'check']"
																					class="text-success"></fa-icon>
																			</td>
																			<td>
																				<fa-icon *ngIf="bill.is_approved"
																					[icon]="['fas', 'check']"
																					class="text-success"></fa-icon>
																			</td>
																			<td>
																				<fa-icon *ngIf="bill.reimbursement"
																					[icon]="['fas', 'check']"
																					class="text-success"></fa-icon>
																			</td>
																			<td>
																				<fa-icon *ngIf="bill.used_in_invoice"
																					[icon]="['fas', 'check']"
																					class="text-success"></fa-icon>
																			</td>
																		</tr>
																	</ng-container>
																	<tr>
																		<th colspan="4" class="text-end">Total</th>
																		<td colspan="7">{{ caseDetails?.total_cost }}
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div [ngClass]="getTabPaneClass(3)">
											<div class="row g-1 feedback" @fadeInOut *ngIf="!loadingFeedback">
												<div class="col-md-12">
													@for (main of feedbackQuestions; track main.que_id) {
													<div class="card">
														<div class="card-header">
															<h5 class="card-title text-dark mb-0">
																{{main.name}}
															</h5>
														</div>
														<div class="card-body">
															<ng-container *ngIf="main.ans_details.length">
																<mat-radio-group [(ngModel)]="main.ans_given"
																	*ngIf="main.ans_details[0].display_name != 'Other'"
																	[disabled]="navbar.userAccess?.Appointments!='Full'">
																	<mat-radio-button [value]="ans.value"
																		[color]="'primary'"
																		*ngFor="let ans of main.ans_details;">
																		{{ans.display_name}}
																	</mat-radio-button>
																</mat-radio-group>
																<textarea class="form-control"
																	[(ngModel)]="main.other_text"
																	*ngIf="main.ans_details[0].display_name == 'Other'"
																	[readonly]="navbar.userAccess?.Appointments!='Full'"></textarea>
																<textarea class="form-control"
																	[(ngModel)]="main.other_text"
																	*ngIf="showOtherInput(main.ans_given,main.ans_details)"
																	[readonly]="navbar.userAccess?.Appointments!='Full'"></textarea>
															</ng-container>
															<ng-container
																*ngIf="!main.ans_details.length && main.sub_questions.length">
																<table class="table table-bordered">
																	<tbody>
																		<tr *ngFor="let sub of main.sub_questions">
																			<th>{{sub.name}}</th>
																			<td>
																				<mat-radio-group
																					[(ngModel)]="sub.ans_given"
																					*ngIf="sub.ans_details[0].display_name != 'Other'"
																					[disabled]="navbar.userAccess?.Appointments!='Full'">
																					<mat-radio-button
																						[value]="ans.value"
																						[color]="'primary'"
																						*ngFor="let ans of sub.ans_details;">
																						{{ans.display_name}}
																					</mat-radio-button>
																				</mat-radio-group>
																			</td>
																		</tr>
																	</tbody>
																</table>
															</ng-container>
														</div>
													</div>
													}
													<div class="card">
														<div class="card-body">
															<button type="button" class="btn btn-sm btn-success"
																[disabled]="saveFeedbackLoader || navbar.userAccess?.Appointments!='Full'"
																(click)="submitFeedback()">
																<fa-icon *ngIf="saveFeedbackLoader"
																	[icon]="['fas', 'spinner']"
																	animation="spin"></fa-icon>
																<fa-icon *ngIf="!saveFeedbackLoader"
																	[icon]="['fas', 'save']"></fa-icon>
																Submit
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div [ngClass]="getTabPaneClass(4)"
											*ngIf="navbar.userAccess?.Follow_up=='Full' || navbar.userAccess?.Follow_up=='Readonly'">
											<div class="row g-1" @fadeInOut *ngIf="!loadingHandover">
												<div class="col-md-12">
													@if (nonMedicalList.length) {
													@for (handover of nonMedicalList; track $index) {
													<div class="card">
														<div class="card-header bg-light">
															<h5 class="card-title text-dark mb-0">
																{{handover.follow_up_date}}
																<strong class="ms-3">
																	{{handover.is_handover?"Handover":"Non-Medical"}}
																</strong>
																<ng-container *ngIf="handover.is_handover_done">
																	<strong class="ms-3">
																		Done
																		<fa-icon [icon]="['fas','check']"
																			class="text-success"></fa-icon>
																	</strong>
																</ng-container>
															</h5>
														</div>
														<div class="card-body"
															[innerHTML]="handover.opd_notes | safeHtml">
														</div>
													</div>
													}
													}@else {
													<div class="card">
														<div class="card-body">
															<h3 class="text-center">
																No Follow-ups
															</h3>
														</div>
													</div>
													}
												</div>
											</div>
										</div>
										@if (
										navbar.userAccess?.Mailbox=='Full' ||
										navbar.userAccess?.Mailbox=='Readonly'
										) {
										<div [ngClass]="getTabPaneClass(5)">
											<div class="card card-body" [@routeAnimations]="prepareRoute(mail_outlet)">
												<router-outlet #mail_outlet="outlet">
												</router-outlet>
											</div>
										</div>
										}
										<div [ngClass]="getTabPaneClass(6)">
											<div class="card overflow-x-hidden">
												<div class="card-header p-1 mb-0">
													<h5 class="card-title text-dark mb-0">
														Case Notes
													</h5>
												</div>
												<div class="card-body overflow-y-auto notes-max-height">
													<table class="table">
														<tbody>
															<tr
																*ngFor="let notes of caseDetails?.opd_notes;let i = index;">
																<td>
																	<p class="mb-0">
																		<label>Date: </label>
																		{{notes?.follow_up_date}}
																	</p>
																	<p class="mb-0">
																		<label>Medical Centre: </label>
																		{{notes?.dropoff_hospital}}
																	</p>
																	<p class="mb-0">
																		<label>Notes: </label>
																		<span *ngIf="notes?.opd_notes"
																			[innerHTML]="notes?.opd_notes | safeHtml"
																			class="case-notes-html"></span>
																	</p>
																	<p class="mb-0">
																		<label>Updated by: </label>
																		{{notes?.opd_notes_updated_by || "___"}}
																	</p>
																	<p class="mb-0">
																		<label>Updated At: </label>
																		{{notes?.opd_notes_updated_at || "___"}}
																	</p>
																	<div *ngIf="notes.lab_test_files"
																		class="card p-2 d-block">
																		<ng-container
																			*ngFor="let files of notes.lab_test_files;let j = index;">
																			<div *ngFor="let file of files.files;let k = index;"
																				class="icon-container">
																				<file-icon [file]="file"></file-icon>
																				<fa-icon
																					[icon]="['fas', 'times-circle']"
																					class="delete-icon text-danger"
																					matTooltip="Delete"
																					(click)="deleteFollowupFile(file,i,j,k);"></fa-icon>
																			</div>
																		</ng-container>
																		<p class="mb-0"
																			*ngIf="!notes.lab_test_files.length">
																			No Files
																		</p>
																	</div>
																</td>
															</tr>
															<tr *ngIf="!caseDetails?.opd_notes?.length">
																<td class="text-center">No notes found.</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
										<div [ngClass]="getTabPaneClass(7)">
											@if(fetchingCandFiles){
											<h3 class="text-center">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading files...
											</h3>
											}@else{
											<div class="row g-1">
												<div class="col">
													<div class="card">
														<div class="card-header">
															<h5 style="font-size: 12px !important;"
																class="card-title text-dark mb-0">
																Chat Files
															</h5>
														</div>
														<div class="card-body scroll-table-container">
															<table class="table table-bordered less-padding">
																<thead>
																	<tr>
																		<th style="width: 5% !important;">#</th>
																		<th style="width: 25% !important;">Name</th>
																		<th style="width: 35% !important;">Files</th>
																		<th style="width: 10% !important;"
																			class="text-center">
																			Is Receipt
																		</th>
																		<th style="width: 10% !important;"
																			class="text-end">
																			Amount
																		</th>
																		<th style="width: 10% !important;"
																			class="text-end">
																			Date
																		</th>
																		<th style="width: 5% !important;"
																			class="text-end">
																			Action
																		</th>
																	</tr>
																</thead>
																<tbody>
																	@if(candidateAndChatFiles.length){
																	@for (
																	fl of candidateAndChatFiles;
																	track fl;
																	let j = $index;
																	) {
																	<tr>
																		<td>
																			<mat-checkbox [color]="'primary'"
																				[(ngModel)]="fl.selected">
																			</mat-checkbox>
																			{{j + 1}}
																		</td>
																		<td>
																			{{fl.file_name}}
																		</td>
																		<td>
																			<div class="row g-0">
																				<div class="col">
																					@if (fl.file_url) {
																					@for (
																					file of fl.file_url;
																					track file;
																					let k = $index;
																					) {
																					<div
																						class="icon-container no-delete">
																						<file-icon
																							[file]="file"></file-icon>
																					</div>
																					}
																					}
																				</div>
																			</div>
																			<!-- <div class="row g-0">
																				<div class="col">
																					<ng-select [items]="followupList"
																						bindValue="id"
																						placeholder="Select Follow-up"
																						[(ngModel)]="fl.selectedFollowupForCandFile"
																						appearance="outline"
																						(change)="followupForCandFileSelected(fl.id,fl.selectedFollowupForCandFile)">
																						<ng-template ng-label-tmp
																							let-item="item">
																							{{item.follow_up_date}}
																							&nbsp;|&nbsp;
																							{{item.visit_type?.name}}
																							<span
																								class="badge fw-bold text-dark"
																								[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
																								{{
																								item?.follow_up_status?.name
																								}}
																							</span>
																						</ng-template>
																						<ng-template ng-option-tmp
																							let-item="item"
																							let-search="searchTerm"
																							let-index="index">
																							{{item.follow_up_date}}
																							&nbsp;|&nbsp;
																							{{item.visit_type?.name}}
																							<span
																								class="badge fw-bold text-dark"
																								[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
																								{{
																								item?.follow_up_status?.name
																								}}
																							</span>
																						</ng-template>
																					</ng-select>
																				</div>
																			</div> -->
																		</td>
																		<td class="text-center">
																			@if(fl.is_payment_receipt){
																			<fa-icon [icon]="['fas','check-square']"
																				class="text-success"></fa-icon>
																			}
																		</td>
																		<td class="text-end">
																			{{fl.amount}}
																		</td>
																		<td class="text-end">
																			{{fl.updated_at}}
																		</td>
																		<td class="text-end">
																			<button class="btn btn-xs btn-danger"
																				matTooltip="Delete"
																				(click)="removeCandidateFile(fl.id)">
																				<fa-icon
																					[icon]="['fas','times']"></fa-icon>
																			</button>
																		</td>
																	</tr>
																	}
																	}@else{
																	<tr>
																		<td class="text-center" colspan="7">
																			No Files
																		</td>
																	</tr>
																	}
																</tbody>
																@if(candidateAndChatFiles.length){
																<tfoot>
																	<tr>
																		<td colspan="7">
																			<button type="button"
																				class="btn btn-xs btn-success"
																				(click)="selectFiles('bill')">
																				Select for billing
																			</button>
																			<button type="button"
																				class="btn btn-xs btn-success ms-1"
																				(click)="selectFiles('file')">
																				Select for files
																			</button>
																		</td>
																	</tr>
																</tfoot>
																}
															</table>
														</div>
													</div>
												</div>
											</div>
											}
										</div>
										@if (
										navbar.userAccess?.Call_Recordings=='Full' ||
										navbar.userAccess?.Call_Recordings=='Readonly'
										) {
										<div [ngClass]="getTabPaneClass(8)">
											@if(fetchingRecordings){
											<h3 class="text-center">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading recordings...
											</h3>
											}@else{
											<div class="row g-1">
												<div class="col">
													<div class="card">
														<div class="card-header">
															<h5 style="font-size: 12px !important;"
																class="card-title text-dark mb-0">
																Call Recordings
															</h5>
														</div>
														<div class="card-body scroll-table-container">
															<table class="table table-bordered less-padding">
																<thead>
																	<tr>
																		<th style="width: 10% !important;">#</th>
																		<th style="width: 70% !important;">File</th>
																		<th style="width: 15% !important;">Created At
																		</th>
																		<th style="width: 5% !important;">Play</th>
																	</tr>
																</thead>
																<tbody>
																	@if(callRecordings.length){
																	@for (
																	rec of callRecordings;
																	track rec;
																	let i = $index;
																	) {
																	<tr>
																		<td>
																			{{i + 1}}
																		</td>
																		<td>
																			{{getFileName(rec.filepath)}}
																		</td>
																		<td>
																			{{rec.created_at}}
																		</td>
																		<td>
																			<a class="btn btn-xs btn-primary"
																				href="{{rec.filepath}}" target="_blank">
																				<fa-icon
																					[icon]="['fas','play-circle']"></fa-icon>
																			</a>
																		</td>
																	</tr>
																	}
																	}@else{
																	<tr>
																		<td class="text-center" colspan="4">
																			No Recordings
																		</td>
																	</tr>
																	}
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
											}
										</div>
										}
										<div [ngClass]="getTabPaneClass(9)">
											@if(fetchingAdminNotes){
											<h3 class="text-center">
												<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
												Loading notes...
											</h3>
											}@else{
											<div class="row g-1">
												<div class="col">
													<div class="card">
														<div class="card-header p-1 mb-0">
															<h5 class="card-title text-dark mb-0">
																Administrative Notes
																<button class="btn btn-sm btn-success float-end"
																	(click)="openAdminNotesModal()">
																	<fa-icon [icon]="['fas','plus']"></fa-icon>
																	Add Notes
																</button>
															</h5>
														</div>
														<div class="card-body scroll-table-container">
															<table class="table table-bordered less-padding">
																<thead>
																	<tr>
																		<th style="width: 10% !important;">#</th>
																		<th style="width: 50% !important;">Notes</th>
																		<th style="width: 15% !important;">Created At
																		</th>
																		<th style="width: 15% !important;">Last Updated
																			At</th>
																		<th style="width: 10% !important;">Action</th>
																	</tr>
																</thead>
																<tbody>
																	@if(adminNotes.length){
																	@for (
																	rec of adminNotes;
																	track rec;
																	let i = $index;
																	) {
																	<tr>
																		<td>
																			{{i + 1}}
																		</td>
																		<td [innerHTML]="rec.notes | safeHtml">
																		</td>
																		<td>{{rec.created_at}}</td>
																		<td>{{rec.updated_at}}</td>
																		<td>
																			<button type="button"
																				class="btn btn-xs btn-primary"
																				(click)="openAdminNotesModal(rec)"
																				matTooltip="Edit">
																				<fa-icon
																					[icon]="['fas','pencil-alt']"></fa-icon>
																			</button>
																			<button type="button"
																				class="btn btn-xs btn-danger ms-1"
																				(click)="deleteAdminNotes(rec.id)"
																				matTooltip="Delete">
																				<fa-icon
																					*ngIf="deleteLoaderAdminNote !== rec.id"
																					[icon]="['fas', 'times']"></fa-icon>
																				<fa-icon
																					*ngIf="deleteLoaderAdminNote === rec.id"
																					[icon]="['fas', 'spinner']"
																					animation="spin"></fa-icon>
																			</button>

																		</td>
																	</tr>
																	}
																	}@else{
																	<tr>
																		<td class="text-center" colspan="5">
																			No records
																		</td>
																	</tr>
																	}
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
											}
										</div>
										<div [ngClass]="getTabPaneClass(10)">
											<div class="card overflow-x-hidden">
												<div class="card-header p-1 mb-0">
													<h5 class="card-title text-dark mb-0">
														Onboard Case Details
														@if (navbar.userAccess?.Appointments == 'Full'){
														<span matTooltip="Link to HC"
															class="badge bg-warning text-light float-end" role="button"
															(click)="openCaseIdModal()"
															*ngIf="isSCCase(caseDetails?.case_id)">
															<fa-icon [icon]="['fas','link']"></fa-icon>
														</span>
														<span matTooltip="Unlink from HC"
															class="badge bg-danger text-light float-end me-1"
															role="button" (click)="unlinkFromHC()"
															*ngIf="!isSCCase(caseDetails?.case_id)">
															<fa-icon [icon]="['fas','unlink']"></fa-icon>
														</span>
														}
													</h5>
												</div>
												<div class="card-body overflow-y-auto notes-max-height">
													<table class="table">
														<tbody>
															<tr>
																<td>
																	<p class="mb-0">
																		<label>Initial Complaints</label>
																	</p>
																	<div class="col-sm-12 pl-xl">
																		<span *ngIf="caseDetails?.initial_complaints"
																			[innerHTML]="caseDetails?.initial_complaints | safeHtml"></span>
																		<span *ngIf="!caseDetails?.initial_complaints">
																			___
																		</span>
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<div class="row g-0">
																		<div class="col">
																			<p class="mb-0">
																				<label>
																					Sign-off Date
																					@if (navbar.userAccess?.Appointments
																					== 'Full'){
																					<fa-icon [icon]="['fas','edit']"
																						role="button"
																						(click)="openSignOffModal()"></fa-icon>
																					}
																				</label>
																			</p>
																			<div class="col-sm-12 pl-xl">
																				{{caseDetails?.sign_off_date || "___"}}
																			</div>
																		</div>
																		<div class="col">
																			<p class="mb-0">
																				<label>Sign-off By</label>
																				<!-- <fa-icon [icon]="['fas','edit']"
																					role="button"
																					(click)="openSignOffByModal()"></fa-icon> -->
																			</p>
																			<div class="col-sm-12 pl-xl">
																				{{caseDetails?.sign_off_by || "___"}}
																			</div>
																		</div>
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<div class="row g-0">
																		<div class="col">
																			<p class="mb-0">
																				<label>Symptoms</label>
																			</p>
																			<div class="col-sm-12 pl-xl">
																				<div *ngIf="caseDetails?.symptoms">
																					<span
																						*ngFor="let sysd of caseDetails?.symptoms;last as isLast;"
																						class="fs_14">
																						{{sysd}}{{isLast ? '' : ', '}}
																					</span>
																				</div>
																				<div
																					*ngIf="!caseDetails?.symptoms || !caseDetails?.symptoms.length">
																					___
																				</div>
																			</div>
																		</div>
																		<div class="col">
																			<p class="mb-0">
																				<label>Sub-Symptoms</label>
																			</p>
																			<div class="col-sm-12 pl-xl">
																				<div *ngIf="subsymptoms.length">
																					<span
																						*ngFor="let sysd of subsymptoms;last as isLast;"
																						class="fs_14">
																						{{sysd}}{{isLast ? '' : ', '}}
																					</span>
																				</div>
																				<div *ngIf="!subsymptoms.length">
																					___
																				</div>
																			</div>
																		</div>
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<p class="mb-0">
																		<label>Medications Onboard</label>
																	</p>
																	<div class="col-sm-12">
																		<table
																			class="table table-striped table-bordered"
																			*ngIf="caseDetails?.medications_onboard?.length > 0"
																			id="medicineTable">
																			<thead>
																				<tr>
																					<th matTooltip="Date">
																						<fa-icon
																							[icon]="['fas','calendar']"></fa-icon>
																					</th>
																					<th matTooltip="Name">
																						<fa-icon
																							[icon]="['fas','medkit']"></fa-icon>
																					</th>
																					<th matTooltip="Dosage">
																						<fa-icon
																							[icon]="['fas','medkit']"></fa-icon>
																					</th>
																					<th matTooltip="Frequency">
																						<fa-icon
																							[icon]="['fas','list-ol']"></fa-icon>
																					</th>
																					<th matTooltip="No. Of Days">
																						<fa-icon
																							[icon]="['fas','calendar-alt']"></fa-icon>
																					</th>
																				</tr>
																			</thead>
																			<tbody>
																				<tr
																					*ngFor="let field of caseDetails?.medications_onboard; let i = index">
																					<td>
																						{{field.medDate }}
																					</td>
																					<td>
																						{{field.name}}
																					</td>
																					<td>
																						{{field.qty}}
																					</td>
																					<td>
																						<fa-icon *ngIf="field.morning"
																							[icon]="['fas','sun']"
																							class="text-success me-1"
																							matTooltip="Morning"></fa-icon>
																						<fa-icon *ngIf="field.afternoon"
																							[icon]="['fas','sun']"
																							class="text-warning me-1"
																							matTooltip="Afternoon"></fa-icon>
																						<fa-icon *ngIf="field.evening"
																							[icon]="['fas','moon']"
																							class="text-primary me-1"
																							matTooltip="Evening"></fa-icon>
																						<fa-icon *ngIf="field.sos"
																							[icon]="['fas','exclamation-triangle']"
																							class="text-danger me-1"
																							matTooltip="SOS"></fa-icon>
																					</td>
																					<td>
																						{{field.noOfDays}}
																					</td>
																				</tr>
																			</tbody>
																		</table>
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<p class="mb-0">
																		<label>Medical Summary</label>
																	</p>
																	<div class="col-sm-12 pl-xl">
																		<span *ngIf="caseDetails?.medical_summary"
																			[innerHTML]="caseDetails?.medical_summary | safeHtml"></span>
																		<span *ngIf="!caseDetails?.medical_summary">
																			___
																		</span>
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<div class="row g-0">
																		<div class="col">
																			<p class="mb-0">
																				<label>Reported As</label>
																			</p>
																			<div class="col-sm-12 pl-xl">
																				{{caseDetails?.reported_as || "___"}}
																			</div>
																		</div>
																		<div class="col">
																			<p class="mb-0">
																				<label>Port Visit?</label>
																			</p>
																			<div class="col-sm-12 pl-xl">
																				{{getPortVisitText(caseDetails?.port_visit_done)
																				||
																				"___"}}
																			</div>
																		</div>
																		<div class="col">
																			<p class="mb-0">
																				<label>Assigned Dr. RMA</label>
																			</p>
																			<div class="col-sm-12 pl-xl">
																				{{caseDetails?.assigned_dr_rma ||
																				"___"}}
																			</div>
																		</div>
																	</div>
																</td>
															</tr>
															<tr>
																<td>
																	<p class="mb-0">
																		<label>
																			Crew Chronic Conditions
																			@if (navbar.userAccess?.Appointments ==
																			'Full'){
																			<fa-icon [icon]="['fas','edit']"
																				role="button"
																				(click)="openChronicModal()"></fa-icon>
																			}
																		</label>
																	</p>
																	<div class="col-sm-12 pl-xl">
																		{{caseDetails?.crew_chronic_conditions ||
																		"___"}}
																	</div>
																</td>
															</tr>
															<!-- <tr>
																<td>Initial Complaints</td>
																<th colspan="3">
																	<span *ngIf="caseDetails?.initial_complaints"
																		[innerHTML]="caseDetails?.initial_complaints | safeHtml"></span>
																	<span *ngIf="!caseDetails?.initial_complaints">
																		___
																	</span>
																</th>
															</tr>
															<tr>
																<td style="width:20% !important;">
																	Sign-off Date
																</td>
																<th style="width:30% !important;">
																	{{caseDetails?.sign_off_date || "___"}}
																	@if (navbar.userAccess?.Appointments
																	== 'Full'){
																	<fa-icon [icon]="['fas','edit']" role="button"
																		(click)="openSignOffModal()">
																	</fa-icon>
																	}
																</th>
																<td style="width:20% !important;">
																	Sign-off By
																</td>
																<th style="width:30% !important;">
																	{{caseDetails?.sign_off_by || "___"}}
																	<fa-icon [icon]="['fas','edit']" role="button"
																		(click)="openSignOffByModal()">
																	</fa-icon>
																</th>
															</tr>
															<tr>
																<td>Symptoms</td>
																<th colspan="3">
																	@if(!caseDetails?.symptoms ||
																	!caseDetails?.symptoms.length){
																	___
																	}@else{
																	@for(
																	sysd of caseDetails?.symptoms;
																	track sysd;
																	let isLast = $last
																	){
																	<span class="fs_14">
																		{{sysd}}{{isLast ? '' : ', '}}
																	</span>
																	}
																	}
																</th>
															</tr>
															<tr>
																<td>Sub-Symptoms</td>
																<th colspan="3">
																	@if(subsymptoms.length){
																	@for(
																	sysd of subsymptoms;
																	track sysd;
																	let isLast = $last
																	){
																	<span class="fs_14">
																		{{sysd}}{{isLast ? '' : ', '}}
																	</span>
																	}
																	}@else{
																	___
																	}
																</th>
															</tr>
															<tr>
																<td>Medications Onboard</td>
																<th colspan="3">
																	<table class="table table-striped table-bordered"
																		*ngIf="caseDetails?.medications_onboard?.length > 0"
																		id="medicineTable">
																		<thead>
																			<tr>
																				<th matTooltip="Date">
																					<fa-icon
																						[icon]="['fas','calendar']"></fa-icon>
																				</th>
																				<th matTooltip="Name">
																					<fa-icon
																						[icon]="['fas','medkit']"></fa-icon>
																				</th>
																				<th matTooltip="Dosage">
																					<fa-icon
																						[icon]="['fas','medkit']"></fa-icon>
																				</th>
																				<th matTooltip="Frequency">
																					<fa-icon
																						[icon]="['fas','list-ol']"></fa-icon>
																				</th>
																				<th matTooltip="No. Of Days">
																					<fa-icon
																						[icon]="['fas','calendar-alt']"></fa-icon>
																				</th>
																			</tr>
																		</thead>
																		<tbody>
																			<tr
																				*ngFor="let field of caseDetails?.medications_onboard; let i = index">
																				<td>
																					{{field.medDate }}
																				</td>
																				<td>
																					{{field.name}}
																				</td>
																				<td>
																					{{field.qty}}
																				</td>
																				<td>
																					<fa-icon *ngIf="field.morning"
																						[icon]="['fas','sun']"
																						class="text-success me-1"
																						matTooltip="Morning"></fa-icon>
																					<fa-icon *ngIf="field.afternoon"
																						[icon]="['fas','sun']"
																						class="text-warning me-1"
																						matTooltip="Afternoon"></fa-icon>
																					<fa-icon *ngIf="field.evening"
																						[icon]="['fas','moon']"
																						class="text-primary me-1"
																						matTooltip="Evening"></fa-icon>
																					<fa-icon *ngIf="field.sos"
																						[icon]="['fas','exclamation-triangle']"
																						class="text-danger me-1"
																						matTooltip="SOS"></fa-icon>
																				</td>
																				<td>
																					{{field.noOfDays}}
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</th>
															</tr>
															<tr>
																<td>Medical Summary</td>
																<th colspan="3">
																	@if(caseDetails?.medical_summary){
																	<span
																		[innerHTML]="caseDetails?.medical_summary | safeHtml"></span>
																	}@else{
																	___
																	}
																</th>
															</tr>
															<tr>
																<td>Reported As</td>
																<th>
																	{{caseDetails?.reported_as || "___"}}
																</th>
																<td>Port Visit?</td>
																<th>
																	{{getPortVisitText(caseDetails?.port_visit_done) ||
																	"___"}}
																</th>
															</tr>
															<tr>
																<td>Assigned Dr. RMA</td>
																<th colspan="3">
																	{{caseDetails?.assigned_dr_rma || "___"}}
																</th>
															</tr>
															<tr>
																<td>
																	Crew Chronic Conditions
																</td>
																<th colspan="3">
																	{{caseDetails?.crew_chronic_conditions ||
																	"___"}}
																	@if (navbar.userAccess?.Appointments ==
																	'Full'){
																	<fa-icon [icon]="['fas','edit']" role="button"
																		(click)="openChronicModal()"></fa-icon>
																	}
																</th>
															</tr> -->
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
@if (navbar.userAccess?.Appointments!='Full' && navbar.userAccess?.Appointments!='Readonly'){
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}
<div class="modal fade" id="adminNotesModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<form [formGroup]="adminNotesForm" (ngSubmit)="submitAdminNotes()">
				<div class="modal-header text-center">
					<h4 class="modal-title">
						<strong>Administrative Notes</strong>
					</h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeAdminNotesModal()">
					</button>
				</div>
				<div class="modal-body">
					<div class="row g-1 mb-3">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<div class="mb-editor text_editor_container">
								<quill-editor formControlName="notes" [modules]="quillConfig"
									placeholder="Notes..."></quill-editor>
							</div>
							<p *ngIf="showError1('notes')" class="text-danger">
								<span *ngIf="f1.notes.errors?.required">
									Required
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="submitAdminNotesLoader">
						<fa-icon *ngIf="submitAdminNotesLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						<fa-icon *ngIf="!submitAdminNotesLoader" [icon]="['fas', 'save']"></fa-icon>
						@if(f1.id.value){
						Update
						}@else{
						Save
						}
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal"
						(click)="reverseMarkForClosure()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="triageModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Triage Code</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<ng-select [items]="triageList" bindValue="val" [clearable]="true" placeholder="Select Triage"
							[(ngModel)]="triageCode" appearance="outline">
							<ng-template ng-label-tmp let-item="item">
								<fa-icon [icon]="['fas', 'flag']" [ngClass]="'text-'+item.color"></fa-icon>
								{{item.text}}
							</ng-template>
							<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
								<fa-icon [icon]="['fas', 'flag']" [ngClass]="'text-'+item.color"></fa-icon>
								{{item.text}}
							</ng-template>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveTriage()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="signOffByModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Sign-off By</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<select class="form-select" [(ngModel)]="sign_off_by_model">
							<option>Select</option>
							<option value="3C">3 Cube</option>
							<option value="CO">Company</option>
						</select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveSignOffBy()"
					[disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="caseCategoryModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Case Category</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-6">
						<ng-select [items]="allCaseCategories" bindValue="id" bindLabel="name" [clearable]="true"
							placeholder="Select Case Category" [(ngModel)]="case_category_id" appearance="outline">
						</ng-select>
					</div>
					<div class="col-lg-6">
						<mat-checkbox [color]="'primary'" [(ngModel)]="work_related"
							(change)="keyEvalChanged('work_related')">
							Work related
						</mat-checkbox>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveCaseCat()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="caseStatusModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<form [formGroup]="moduleForm" (ngSubmit)="saveCaseStatus()">
				<div class="modal-header text-center">
					<h4 class="modal-title">
						<strong>Case Status</strong>
					</h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal" (click)="reverseMarkForClosure()">
					</button>
				</div>
				<div class="modal-body">
					<div class="row g-1 mb-3">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showError('status4_id')}" [items]="status4List"
								bindLabel="name" bindValue="id" [clearable]="true" id="status4_id"
								formControlName="status4_id" placeholder="Closure Status*" [appearance]="'outline'">
							</ng-select>
							<p *ngIf="showError('status4_id')" class="text-danger">
								<span *ngIf="f.status4_id.errors?.required">
									Required
								</span>
							</p>
						</div>
					</div>
					<div class="row g-1 mb-3">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<label class="form-label">Closure Notes*:</label>
							<quill-editor id="closure_notes" formControlName="closure_notes" [modules]="quillConfig"
								[placeholder]="'Notes'"></quill-editor>
							<p *ngIf="showError('closure_notes')" class="text-danger">
								<span *ngIf="f.closure_notes.errors?.required">
									Required
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="updateLoader">
						<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
						Update
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal"
						(click)="reverseMarkForClosure()">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="keyEvalModal" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Key Evaluations</strong></h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal" (click)="getCaseDetails();"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1 mb-lg">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<table class="table table-bordered">
							<thead>
								<tr>
									<th style="width: 10% !important;"></th>
									<th style="width: 20% !important;">
										Diagnosis
										<span class="text-danger">*</span>
									</th>
									<th style="width: 15% !important;">ICD Code</th>
									<!-- <th style="width: 15% !important;">Surgery Required</th>
									<th style="width: 15% !important;">Hospitalized</th> -->
									<th style="width: 10% !important;">Any Disability</th>
									<th style="width: 15% !important;">Expected Closure</th>
									<th style="width: 15% !important;">Date of Arrival</th>
									<th style="width: 15% !important;">Fitness Date</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<th></th>
									<td>
										<input class="form-control" [(ngModel)]="caseDetails['diagnosis']"
											(keyup)="keyEvalChanged('diagnosis')" />
									</td>
									<td>
										<input class="form-control" [(ngModel)]="caseDetails['icd_code']"
											(keyup)="keyEvalChanged('icd_code')" />
									</td>
									<!-- <td>
										<select class="form-select" [(ngModel)]="caseDetails['surgery_required']"
											(change)="keyEvalChanged('surgery_required')">
											<option value="">Select</option>
											<option value="Yes">Yes</option>
											<option value="No">No</option>
										</select>
									</td>
									<td>
										<select class="form-select" [(ngModel)]="caseDetails['hospitalized_required']"
											(change)="keyEvalChanged('hospitalized_required')">
											<option value="">Select</option>
											<option value="Yes">Yes</option>
											<option value="No">No</option>
											<option value="Discharged">Discharged</option>
										</select>
									</td> -->
									<td>
										<select class="form-select" [(ngModel)]="caseDetails['disability']"
											(change)="keyEvalChanged('disability')">
											<option value="">Select</option>
											<option value="Yes">Yes</option>
											<option value="Limited">Limited</option>
											<option value="No">No</option>
										</select>
									</td>
									<td>
										<div class="input-group">
											<input class="form-control p-1"
												[(ngModel)]="caseDetails['expected_closure_date']" ngbDatepicker
												id="expected_closure_date" #expected_closure_date="ngbDatepicker"
												[minDate]="minDate"
												(ngModelChange)="keyEvalChanged('expected_closure_date')" />
											<button class="btn btn-outline-secondary"
												(click)="expected_closure_date.toggle()" type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
									</td>
									<td>
										<div class="input-group">
											<input class="form-control p-1" [(ngModel)]="caseDetails['arrival_date']"
												ngbDatepicker id="arrival_date" #arrival_date="ngbDatepicker"
												[minDate]="minDate" (ngModelChange)="keyEvalChanged('arrival_date')" />
											<button class="btn btn-outline-secondary" (click)="arrival_date.toggle()"
												type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
									</td>
									<td>
										<div class="input-group">
											<input class="form-control p-1" [(ngModel)]="caseDetails['fitness_date']"
												ngbDatepicker id="fitness_date" #fitness_date="ngbDatepicker"
												[minDate]="minDate" (ngModelChange)="keyEvalChanged('fitness_date')" />
											<button class="btn btn-outline-secondary" (click)="fitness_date.toggle()"
												type="button">
												<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
											</button>
										</div>
									</td>
								</tr>
								<!-- <tr *ngIf="showHospitalizationDate() || showSurgeryDate() || showDisabilityFields()"></tr> -->
								<tr>
									<td></td>
									<td colspan="2">
										<strong>
											Due To
											<span class="text-danger">*</span>
										</strong>
										<input class="form-control" [(ngModel)]="caseDetails['due_to']"
											(keyup)="keyEvalChanged('due_to')" />
									</td>
									<!-- <th>
										<ng-container *ngIf="showSurgeryDate()">
											Surgery Date
											<div class="input-group">
												<input class="form-control p-1"
													[(ngModel)]="caseDetails['surgery_date']" ngbDatepicker
													id="surgery_date" #surgery_date="ngbDatepicker"
													[minDate]="minDate" />
												<button class="btn btn-outline-secondary"
													(click)="surgery_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
										</ng-container>
									</th>
									<th>
										<ng-container *ngIf="showHospitalizationDate()">
											Hospitalization Date
											<div class="input-group">
												<input class="form-control p-1"
													[(ngModel)]="caseDetails['hospitalized_date']" ngbDatepicker
													id="hospitalized_date" #hospitalized_date="ngbDatepicker"
													[minDate]="minDate" />
												<button class="btn btn-outline-secondary"
													(click)="hospitalized_date.toggle()" type="button">
													<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
												</button>
											</div>
										</ng-container>
									</th> -->
									<th>
										<ng-container *ngIf="showDisabilityFields()">
											Disability %
											<input type="number" class="form-control"
												[(ngModel)]="caseDetails['disability_per']" id="disability_per" />
											Notes
											<input class="form-control" [(ngModel)]="caseDetails['disability_notes']"
												id="disability_notes" />
										</ng-container>
									</th>
									<td colspan="2">
										<strong>
											Expected Treatment Cost
										</strong>
										<input class="form-control" [(ngModel)]="caseDetails['expected_treatment_cost']"
											(keyup)="keyEvalChanged('expected_treatment_cost')" />
									</td>
									<td></td>
								</tr>
								<tr>
									<th>By</th>
									<td>{{caseDetails['diagnosis_by']}}</td>
									<td></td>
									<!-- <td>{{caseDetails['surgery_required_by']}}</td>
									<td>{{caseDetails['hospitalized_required_by']}}</td> -->
									<td>{{caseDetails['disability_by']}}</td>
									<td>{{caseDetails['expected_closure_date_by']}}</td>
									<td>{{caseDetails['arrival_date_by']}}</td>
									<td>{{caseDetails['fitness_date_by']}}</td>
								</tr>
								<tr>
									<th>Date</th>
									<td>{{caseDetails['diagnosis_date']}}</td>
									<td></td>
									<!-- <td>{{caseDetails['surgery_required_date']}}</td>
									<td>{{caseDetails['hospitalized_required_date']}}</td> -->
									<td>{{caseDetails['disability_date']}}</td>
									<td>{{caseDetails['expected_closure_date_date']}}</td>
									<td>{{caseDetails['arrival_date_updated_date']}}</td>
									<td>{{caseDetails['fitness_date_updated_date']}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveKeyEval()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal"
					(click)="getCaseDetails();">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="assigneeModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Shore Care Doctor</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<ng-select [items]="doctorList" bindValue="id" bindLabel="name" [clearable]="true"
							placeholder="Select Doctor" [(ngModel)]="assigned_sc_agent_id" appearance="outline">
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveAssignee()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="caseIdModal" role="dialog">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title mb-0">Link Case To HC</h4>
				<button type="button" class="btn-close" (click)="closeCaseIdModal();"></button>
			</div>
			<div class="modal-body">
				<div class="row mb-2">
					<div class="col-lg-4 col-md-4 col-sm-10 col-xs-10">
						<input id="searchInput" placeholder="Search" [formControl]="searchControl"
							class="form-control" />
					</div>
					<div class="col-lg-2 col-md-2 col-sm-2 col-xs-2">
						<fa-icon *ngIf="fetchCaseIdDetailsLoader" [icon]="['fas', 'spinner']" animation="spin"
							[size]="'2x'"></fa-icon>
					</div>
				</div>
				<ng-container *ngIf="detailsFromCaseId">
					<div class="row mb-2">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<table class="table table-bordered">
								<tbody>
									<tr>
										<th>3C Id</th>
										<td>{{detailsFromCaseId?.cc_id}}</td>
										<th>Candidate Name</th>
										<td>{{detailsFromCaseId?.f_name}} {{detailsFromCaseId?.l_name}}</td>
									</tr>
									<tr>
										<th>Gender</th>
										<td>{{detailsFromCaseId?.gender}}</td>
										<th>D.O.B.</th>
										<td>{{detailsFromCaseId?.dob}}</td>
									</tr>
									<tr>
										<th>Email</th>
										<td>{{detailsFromCaseId?.email}}</td>
										<th>Nationality</th>
										<td>{{detailsFromCaseId?.nationality}}</td>
									</tr>
									<tr>
										<th>Company</th>
										<td>{{detailsFromCaseId?.company}}</td>
										<th>Vessel</th>
										<td>{{detailsFromCaseId?.vessel}}</td>
									</tr>
									<tr>
										<th>Rank</th>
										<td>{{detailsFromCaseId?.rank}}</td>
										<th>Crew Id</th>
										<td>{{detailsFromCaseId?.crew_id}}</td>
									</tr>
									<tr>
										<th>Sign-off By</th>
										<td>{{detailsFromCaseId?.signoff_by}}</td>
										<th>Sign-off Date</th>
										<td>{{detailsFromCaseId?.signoff_date}}</td>
									</tr>
									<tr>
										<th>Reported As</th>
										<td>{{detailsFromCaseId?.reported_as}}</td>
										<th>Assigned Doctor RMA</th>
										<td>{{detailsFromCaseId?.dr_name}}</td>
									</tr>
									<tr>
										<th>Port Visit</th>
										<td>{{detailsFromCaseId?.port_visit}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col">
							<h4><span class="text-decoration-underline">Initial Diagnosis</span></h4>
							<div [innerHTML]="detailsFromCaseId?.initialDiagnosis || '' |safeHtml"></div>
						</div>
						<div class="col">
							<h4><span class="text-decoration-underline">Medical Summary</span></h4>
							<div [innerHTML]="detailsFromCaseId?.medical_summary || '' |safeHtml"></div>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col">
							<h4><span class="text-decoration-underline">Symptoms</span></h4>
							<div *ngIf="detailsFromCaseId?.symptoms.length">
								<span *ngFor="let sysd of detailsFromCaseId?.symptoms;last as isLast;">
									{{sysd}}
									{{isLast ? '' : ', '}}
								</span>
							</div>
							<div *ngIf="!detailsFromCaseId?.symptoms.length">
								___
							</div>
						</div>
						<div class="col">
							<h4><span class="text-decoration-underline">Sub-Symptoms</span></h4>
							<div *ngIf="detailsFromCaseId?.subsymptoms.length">
								<span *ngFor="let sysd of detailsFromCaseId?.subsymptoms;last as isLast;">
									{{sysd}}
									{{isLast ? '' : ', '}}
								</span>
							</div>
							<div *ngIf="!detailsFromCaseId?.subsymptoms.length">
								___
							</div>
						</div>
					</div>
					<div class="row mb-1">
						<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<h4><span class="text-decoration-underline">Medicines</span></h4>
							<table class="table table-striped table-bordered"
								*ngIf="detailsFromCaseId?.medicines.length > 0" id="medicineTable">
								<thead>
									<tr>
										<th>Date</th>
										<th>Name</th>
										<th>Dosage</th>
										<th>Frequency</th>
										<th>Meals</th>
										<th>No. Of Days</th>
										<th>Status</th>
										<th>Notes</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let field of detailsFromCaseId?.medicines; let i = index">
										<td>
											{{field.medDate }}
										</td>
										<td>
											{{field.name}}
										</td>
										<td>
											{{field.qty}}
										</td>
										<td>
											{{getFrequencyText(field)}}
										</td>
										<td>
											{{field.meals}}
										</td>
										<td>
											{{field.noOfDays}}
										</td>
										<td>
											{{field.status}}
										</td>
										<td>
											{{field.notes}}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</ng-container>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="useCaseDetails()"
					[disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" (click)="closeCaseIdModal()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="displayNoteModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>{{modalNotesDetail.heading}}</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12" [innerHTML]="modalNotesDetail.note || '___' | safeHtml">
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="hospitalizationViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Hospitalization Details</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<table class="table table-bordered">
					<tbody>
						<tr>
							<th style="width: 40%;">Hospitalization</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.hospitalization_status ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th>Hospitalization Date</th>
							<td>
								{{
								caseDetails?.other_details?.admission_date ||
								"___"
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="surgeryViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Surgery Details</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<table class="table table-bordered">
					<tbody>
						<tr>
							<th style="width: 40%;">Surgery</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.surgery_status ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th>Surgery Date</th>
							<td>
								{{
								caseDetails?.other_details?.actual_surgery_date ||
								"___"
								}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="disabilityViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Disability Notes</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				{{caseDetails?.disability_notes || "___"}}
				<!-- {{
				caseDetails?.other_details?.disability_notes ||
				"___"
				}} -->
				<!-- <table class="table table-bordered">
					<tbody>
						<tr>
							<th style="width: 40%;">Disability</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.disability_status ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th>Disability %</th>
							<td>
								{{
								caseDetails?.other_details?.disability_per ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th style="width: 40%;">Notes</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.disability_notes ||
								"___"
								}}
							</td>
						</tr>
					</tbody>
				</table> -->
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="physiotherapyViewModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Physiotherapy Notes</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				{{
				caseDetails?.other_details?.physiotherapy_notes ||
				"___"
				}}
				<!-- <table class="table table-bordered">
					<tbody>
						<tr>
							<th style="width: 40%;">Sessions</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.physiotherapy_session_counts
								||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th>Imp. %</th>
							<td>
								{{
								caseDetails?.other_details?.physiotherapy_percentage ||
								"___"
								}}
							</td>
						</tr>
						<tr>
							<th style="width: 40%;">Notes</th>
							<td style="width: 60%;">
								{{
								caseDetails?.other_details?.physiotherapy_notes ||
								"___"
								}}
							</td>
						</tr>
					</tbody>
				</table> -->
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Close
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="signOffModal" role="dialog">
	<div class="modal-dialog modal-sm">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Sign-off Date</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<div class="input-group">
							<div class="form-floating">
								<input class="form-control" placeholder="" [(ngModel)]="signOffDate" ngbDatepicker
									id="signOffDatePicker" #signOffDatePicker="ngbDatepicker" [minDate]="minDate"
									[container]="'body'" />
								<label for="signOffDatePicker">Sign-off Date</label>
							</div>
							<button class="btn btn-outline-secondary" (click)="signOffDatePicker.toggle()"
								type="button">
								<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveSignOff()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="medHistoryModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Medical History</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<quill-editor id="medical_history" [(ngModel)]="medical_history" [modules]="quillConfig"
							[placeholder]="'Text'"></quill-editor>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveMedHistory()"
					[disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="billingModalAppt" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Billing</strong></h4>
				<button type="button" class="btn-close" (click)="closeBillingModal()"></button>
			</div>
			<div class="modal-body">
				<div class="row mb-2">
					<div class="col-4">
						<ng-select [items]="followupList" bindValue="id" placeholder="Select Follow-up"
							[(ngModel)]="selectedFollowupForBilling" appearance="outline" (change)="filterBills()">
							<ng-template ng-label-tmp let-item="item">
								{{item.follow_up_date}}
								&nbsp;|&nbsp;
								{{item.visit_type?.name}}
								<span class="badge fw-bold text-dark"
									[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
									{{ item?.follow_up_status?.name }}
								</span>
							</ng-template>
							<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
								{{item.follow_up_date}}
								&nbsp;|&nbsp;
								{{item.visit_type?.name}}
								<span class="badge fw-bold text-dark"
									[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
									{{ item?.follow_up_status?.name }}
								</span>
							</ng-template>
						</ng-select>
					</div>
				</div>
				@if (selectedAttachments.length && selectedAttType=="bill") {
				<div class="row">
					<div class="col">
						<view-attachments [attachmentsArr]="selectedAttachments" [showDelete]="true">
						</view-attachments>
					</div>
				</div>
				<div class="row mb-1">
					<div class="col">
						<button type="button" class="btn btn-xs btn-warning" (click)="clearSelectedAttachments()">
							Cancel adding attachment
						</button>
					</div>
				</div>
				}
				<div class="row mb-3">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<table class="table table-bordered less-padding">
							<thead>
								<tr>
									<th style="width: 5% !important;">Sr. No.</th>
									<th style="width: 14% !important;">Date</th>
									<th style="width: 8% !important;">Category</th>
									<th style="width: 13% !important;">Notes</th>
									<th style="width: 10% !important;">Amount</th>
									<th style="width: 10% !important;">Files</th>
									<th style="width: 10% !important;">QR Code</th>
									<th style="width: 10% !important;">Gpay</th>
									<th style="width: 5% !important;">Paid</th>
									<th style="width: 5% !important;">Approval</th>
									<th style="width: 5% !important;">Reimbursement</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let bill of billingDetailsForEdit;let i = index;">
									<tr [ngClass]="{ 'orange': !bill.files || bill.files.length==0 }">
										<td>
											{{ i+1 }}
										</td>
										<td>
											<input class="form-control" [(ngModel)]="bill.date" ngbDatepicker
												#date="ngbDatepicker" [minDate]="minDate" [maxDate]="billingMaxDate"
												(click)="date.toggle()" [disabled]="bill.used_in_invoice" />
										</td>
										<td>
											<ng-select [items]="billCategoryList" bindLabel="name" bindValue="id"
												[disabled]="bill.used_in_invoice" [clearable]="false"
												placeholder="Category" [(ngModel)]="bill.category" appearance="outline">
											</ng-select>
										</td>
										<td>
											<input type="text" class="form-control" [readonly]="bill.used_in_invoice"
												[(ngModel)]="bill.notes" />
										</td>
										<td>
											<input type="number" class="form-control" [readonly]="bill.used_in_invoice"
												[(ngModel)]="bill.amount" (ngModelChange)="getBillingTotal();" />
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedBillFiles"
														[uploadFolder]="'follow_up_bills'"
														(uploaded)="billFileUploaded($event,i)" [flag]="true">
													</app-file-upload>
												</div>
												<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.files">
														<div *ngFor="let file of bill.files;let j = index;"
															class="icon-container">
															<file-icon [file]="file"
																(amountFetched)="amountFetched($event,i)"
																[isReceipt]="true"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteBillFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (selectedAttachments.length && selectedAttType=="bill"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success"
														[disabled]="disableBillFileAtt(i)"
														(click)="addMailAttachments(i,'bill_file');">
														@if(disableBillFileAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedBillQRFiles"
														[uploadFolder]="'follow_up_bills'"
														(uploaded)="qrFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.qrcode_files">
														<div *ngFor="let file of bill.qrcode_files;let j = index;"
															class="icon-container">
															<file-icon [file]="file"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteBillQRFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedBillGPayFiles"
														[uploadFolder]="'follow_up_bills'"
														(uploaded)="gpayFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.gpay_files">
														<div *ngFor="let file of bill.gpay_files;let j = index;"
															class="icon-container">
															<file-icon [file]="file"
																(amountFetched)="amountFetched($event,i)"
																[isReceipt]="true"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteBillGpayFile(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (selectedAttachments.length && selectedAttType=="bill"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success"
														[disabled]="disableBillGPayAtt(i)"
														(click)="addMailAttachments(i,'gpay');">
														@if(disableBillGPayAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<!-- <ng-toggle [(ngModel)]="bill.is_paid"
												[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
												[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
												[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
												[labels]="{'unchecked': 'Unpaid','checked': 'Paid'}" [width]="90"
												[disabled]="bill.used_in_invoice"></ng-toggle> -->
											<mat-checkbox [color]="'primary'" [(ngModel)]="bill.is_paid"></mat-checkbox>
										</td>
										<td>
											<!-- <ng-toggle [(ngModel)]="bill.is_approved"
												[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
												[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
												[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
												[labels]="{'unchecked': 'Pending','checked': 'Approved'}" [width]="90"
												[disabled]="bill.used_in_invoice"></ng-toggle> -->
											<mat-checkbox [color]="'primary'"
												[(ngModel)]="bill.is_approved"></mat-checkbox>
										</td>
										<td>
											<!-- <ng-toggle [(ngModel)]="bill.reimbursement"
												[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
												[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
												[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
												[labels]="{'unchecked': 'Pending','checked': 'Done'}" [width]="90"
												[disabled]="bill.used_in_invoice"></ng-toggle> -->
											<mat-checkbox [color]="'primary'"
												[(ngModel)]="bill.reimbursement"></mat-checkbox>
										</td>
										<td>
											<button matTooltip="Delete" type="button" [disabled]="bill.used_in_invoice"
												class="btn btn-xs btn-danger" (click)="removeBillingDetails(i);">
												<fa-icon [icon]="['fas', 'times']"></fa-icon>
											</button>
											<button matTooltip="Save" type="button"
												[disabled]="saveBillLoaderSingle == i"
												class="btn btn-xs btn-success ms-1" (click)="saveSingleBilling(i);">
												@if(saveBillLoaderSingle == i){
												<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
												}@else{
												<fa-icon [icon]="['fas', 'save']"></fa-icon>
												}
											</button>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveBilling()"
					[disabled]="saveBillLoader">
					<fa-icon *ngIf="saveBillLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!saveBillLoader" [icon]="['fas', 'save']"></fa-icon>
					Save
				</button>
				<button type="button" class="btn btn-sm btn-warning" (click)="closeBillingModal()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="rankModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Rank</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<ng-select [items]="rankList" bindLabel="rank" bindValue="rank_id" [clearable]="true"
							[(ngModel)]="rank" placeholder="Rank" appearance="outline">
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveRank()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="addressModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Address</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<div class="form-floating">
							<textarea class="form-control" id="candidate_address" [(ngModel)]="address"
								placeholder=""></textarea>
							<label for="candidate_address">Address</label>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveAddress()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="billingQuestionsModal" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Billing Confirmation</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"
					(click)="cancelBillQuestions()"></button>
			</div>
			<div class="modal-body">
				<div class="row mb-3">
					<div class="col-lg-12">
						<h4 class="mb-0">
							<strong style="font-size: inherit !important;">Q1.</strong>
							Have you got confirmation from candidate that no dues are pending?
						</h4>
						<mat-radio-group [(ngModel)]="candidate_no_dues">
							<mat-radio-button [value]="1" [color]="'primary'">
								Yes
							</mat-radio-button>
							<mat-radio-button [value]="0" [color]="'primary'">
								No
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12">
						<h4 class="mb-0">
							<strong style="font-size: inherit !important;">Q2.</strong>
							Have you got confirmation from vendor that no dues are pending?
						</h4>
						<mat-radio-group [(ngModel)]="vendor_no_dues">
							<mat-radio-button [value]="1" [color]="'primary'">
								Yes
							</mat-radio-button>
							<mat-radio-button [value]="0" [color]="'primary'">
								No
							</mat-radio-button>
						</mat-radio-group>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveBillQuestions()"
					[disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal"
					(click)="cancelBillQuestions()">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="crewIdModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Crew Id</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<div class="form-floating">
							<input class="form-control" id="crew_id" [(ngModel)]="crew_id" placeholder="" />
							<label for="crew_id">Crew Id</label>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveCrewId()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="newFollowupModalCasePage" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<form [formGroup]="newFollowupForm" (ngSubmit)="createNewFollowup()">
				<div class="modal-header">
					<h4 class="modal-title">
						<strong>
							Create New Follow-up
						</strong>
					</h4>
					<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="row mb-2">
						<div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
							<div class="input-group">
								<div class="form-floating">
									<input class="form-control"
										[ngClass]="{'is-invalid':showErrorNewFlwup('new_follow_up_date')}"
										placeholder="" formControlName="new_follow_up_date" ngbDatepicker
										id="new_follow_up_date" #new_follow_up_date="ngbDatepicker" [minDate]="minDate"
										[container]="'body'" />
									<label for="new_follow_up_date">Follow-up Date*</label>
								</div>
								<button class="btn btn-outline-secondary" (click)="new_follow_up_date.toggle()"
									type="button">
									<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
								</button>
							</div>
							<p *ngIf="showErrorNewFlwup('new_follow_up_date')" class="text-danger">
								<span *ngIf="f2.new_follow_up_date.errors?.required">
									Required
								</span>
								<span *ngIf="f2.new_follow_up_date.errors?.incorrect">
									{{customErrorNewFlwup.new_follow_up_date}}
								</span>
							</p>
						</div>
						<div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
							<ng-select [ngClass]="{'is-invalid':showErrorNewFlwup('new_visit_type_id')}"
								[items]="allVisitType" bindLabel="name" bindValue="id" [clearable]="true"
								id="new_visit_type_id" formControlName="new_visit_type_id"
								placeholder="Appointment Type*" [appearance]="'outline'">
								<ng-template ng-label-tmp let-item="item">
									<img src="../../assets/img/appt-types/{{appt_type_images[item.name]}}"
										class="appt-type-img" />
									{{item.name}}
								</ng-template>
								<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
									<img src="../../assets/img/appt-types/{{appt_type_images[item.name]}}"
										class="appt-type-img" />
									{{item.name}}
								</ng-template>
							</ng-select>
							<p *ngIf="showErrorNewFlwup('new_visit_type_id')" class="text-danger">
								<span *ngIf="f2.new_visit_type_id.errors?.required">
									Required
								</span>
								<span *ngIf="f2.new_visit_type_id.errors?.incorrect">
									{{customErrorNewFlwup.new_visit_type_id}}
								</span>
							</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="submit" class="btn btn-sm btn-success" [disabled]="newFollowupLoader">
						<fa-icon *ngIf="newFollowupLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						Create Follow-up
					</button>
					<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
						Cancel
					</button>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal fade" id="chronicModal" role="dialog">
	<div class="modal-dialog modal-md">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Crew Chronic Conditions</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row g-1">
					<div class="col-lg-12">
						<div class="form-floating">
							<textarea class="form-control" id="crew_chronic_conditions"
								[(ngModel)]="crew_chronic_conditions" placeholder=""></textarea>
							<label for="crew_chronic_conditions">Crew Chronic Conditions</label>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-success" (click)="saveChronic()" [disabled]="updateLoader">
					<fa-icon *ngIf="updateLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!updateLoader" [icon]="['fas', 'save']"></fa-icon>
					Update
				</button>
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="followUpListForMailFileModal" role="dialog">
	<div class="modal-dialog modal-fullscreen">
		<div class="modal-content">
			<div class="modal-header text-center">
				<h4 class="modal-title">
					<strong>Select Follow-up to link file(s)</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row mb-2">
					<div class="col-4">
						<ng-select [items]="followupList" bindValue="id" placeholder="Select Follow-up"
							[(ngModel)]="selectedFollowupForFile" appearance="outline" (change)="getFollowUpFiles()">
							<ng-template ng-label-tmp let-item="item">
								{{item.follow_up_date}}
								&nbsp;|&nbsp;
								{{item.visit_type?.name}}
								<span class="badge fw-bold text-dark"
									[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
									{{ item?.follow_up_status?.name }}
								</span>
							</ng-template>
							<ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
								{{item.follow_up_date}}
								&nbsp;|&nbsp;
								{{item.visit_type?.name}}
								<span class="badge fw-bold text-dark"
									[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
									{{ item?.follow_up_status?.name }}
								</span>
							</ng-template>
						</ng-select>
					</div>
				</div>
				@if (selectedAttachments.length && selectedAttType=="file") {
				<div class="row mb-2">
					<div class="col">
						<view-attachments [attachmentsArr]="selectedAttachments" [showDelete]="true">
						</view-attachments>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col">
						<button type="button" class="btn btn-xs btn-warning" (click)="clearSelectedAttachments()">
							Cancel adding attachment
						</button>
					</div>
				</div>
				}
				@if(selectedFollowupForFile){
				<div class="row mb-2">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<table class="table table-bordered less-padding">
							<thead>
								<tr>
									<th style="width: 25% !important;">Name</th>
									<th style="width: 70% !important;">Files</th>
									<th style="width: 5% !important;">Action</th>
								</tr>
							</thead>
							<tbody>
								<ng-container *ngFor="let bill of followupFilesForEdit;let i = index;">
									<tr [ngClass]="{ 'orange': !bill.file_url || bill.file_url.length==0 }">
										<td>
											<input type="text" class="form-control" [(ngModel)]="bill.file_name" />
										</td>
										<td>
											<div class="row g-0">
												<div class="col-lg-1 col-md-1 col-sm-12 col-xs-12">
													<app-file-upload [allowedFiles]="allowedFiles"
														[uploadFolder]="'follow_up_files'"
														(uploaded)="followUpFileUploaded($event,i)">
													</app-file-upload>
												</div>
												<div class="col-lg-11 col-md-11 col-sm-12 col-xs-12 ps-0">
													<ng-container *ngIf="bill.file_url">
														<div *ngFor="let file of bill.file_url;let j = index;"
															class="icon-container">
															<file-icon [file]="file"></file-icon>
															<fa-icon [icon]="['fas', 'times-circle']"
																class="delete-icon text-danger" matTooltip="Delete"
																(click)="deleteFollowupFile_1(file,i,j);"></fa-icon>
														</div>
													</ng-container>
												</div>
											</div>
											@if (selectedAttachments.length && selectedAttType=="file"){
											<div class="row g-0">
												<div class="col">
													<button matTooltip="Add attachments here" type="button"
														class="btn btn-xs btn-success" [disabled]="disableFileAtt(i)"
														(click)="addMailAttachments(i,'file');">
														@if(disableFileAtt(i)){
														<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'">
														</fa-icon>
														}@else{
														<fa-icon [icon]="['fas', 'paperclip']">
														</fa-icon>
														}
													</button>
												</div>
											</div>
											}
										</td>
										<td>
											<button matTooltip="Delete" type="button" class="btn btn-sm btn-danger"
												(click)="removeFileDetails(i);">
												<fa-icon [icon]="['fas', 'times']"></fa-icon>
											</button>
										</td>
									</tr>
								</ng-container>
							</tbody>
						</table>
						@if (follFilesLoader) {
						<p class="mb-0 text-center fw-bold">
							<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
							Loading...
						</p>
						}
					</div>
				</div>
				}
			</div>
			<div class="modal-footer">
				@if(selectedFollowupForFile){
				<button type="button" class="btn btn-sm btn-primary float-start" (click)="addFiles()">
					<fa-icon [icon]="['fas', 'plus']"></fa-icon>
					Add Files
				</button>
				<button type="button" class="btn btn-sm btn-success" (click)="saveFiles_1()"
					[disabled]="saveFileLoader">
					<fa-icon *ngIf="saveFileLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
					<fa-icon *ngIf="!saveFileLoader" [icon]="['fas', 'save']"></fa-icon>
					Save
				</button>
				}
				<button type="button" class="btn btn-sm btn-warning" data-bs-dismiss="modal">
					Cancel
				</button>
			</div>
		</div>
	</div>
</div>
<!-- <button class="btn btn-md btn-success chat-button" (click)="openForm($event)" matTooltip="Connect with candidate"
	[disabled]="initializingChat">
	@if(initializingChat){
	<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
	}@else{
	<fa-icon [icon]="['fas', 'comment']"></fa-icon>
	}
</button> -->
@if (navbar.userAccess?.Chat=='Full' || navbar.userAccess?.Chat=='Readonly'){
<button class="btn btn-lg btn-success chat-button" (click)="openForm($event)" matTooltip="Connect with candidate"
	[disabled]="initializingChat">
	@if(initializingChat){
	<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
	}@else{
	<div class="icon-wrapper">
		@if(joinStatus.isJoined || channel_exist){
		<app-call-icon></app-call-icon>
		}@else{
		<fa-icon [icon]="['fas', 'comment']"></fa-icon>
		}
		<span class="msg-count" *ngIf="unreadCount$ | async as count">
			{{ count > 99 ? '99+' : count }}
		</span>
		<!-- <span class="msg-count">99</span> -->
	</div>
	}
</button>
}
<div class="main-video-popup bg-light text-light d-flex flex-column shadow-lg hide-video-call"
	id="highlightedVideoPopup">
	<div class="pe-3 py-1 bg-theme">
		<fa-icon [icon]="['fas', 'minus']" role="button" class="text-light float-end" matTooltip="Minimize"
			(click)="minimizeMain()">
		</fa-icon>
	</div>
	<div class="main-video-container">
		@if(currentVideo){
		<div id="{{currentVideo.user.uid}}" style="width: 100%;">
		</div>
		}
	</div>
</div>
<div class="call-popup bg-light text-light d-flex flex-column shadow-lg hide-video-call"
	[ngClass]="{ 'drag-over-active': isDraggingOver }" id="videoCallPopup" (dragenter)="onDragEnter($event)"
	(dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
	<div
		class="chat-header d-flex justify-content-between align-items-center px-3 py-2 border-bottom border-secondary bg-theme">
		<span>
			@if(joinStatus.isJoined){
			<app-call-icon [size]="'20'"></app-call-icon>
			}
			Connect with candidate
		</span>
		<fa-icon [icon]="['fas','times']" (click)="closeForm()" role="button"></fa-icon>
	</div>
	<div class="video-section position-relative flex-grow-1 p-2" id="mainVideoContainer"
		[hidden]="!showVideoContainer()">
		<div style="height:200px;overflow-y:auto;">
			@for(callId of remoteCalls;track callId;let i = $index;){
			@if(showDiv(callId.user.uid)){
			<div class="remote-video-main rounded" (click)="highlightStream(i)"
				[ngStyle]="{'height.px': videoHeightRemote,'width.px': videoWidthRemote}" id="{{callId.user.uid}}">
			</div>
			}
			}
		</div>
		<div class="local-video-overlay rounded" [ngStyle]="{'height.px': videoHeightLocal,'width.px': videoWidthLocal}"
			id="agora_local"></div>
	</div>
	<div class="controls d-flex justify-content-around">
		@if(joinStatus.isJoined){
		<button class="btn btn-light control-btn" (click)="toggleMute()"
			matTooltip="{{isMute?'Unmute audio':'Mute audio'}}">
			@if(isMute){
			<fa-icon [icon]="['fas','microphone-slash']"></fa-icon>
			}@else{
			<fa-icon [icon]="['fas','microphone']"></fa-icon>
			}
		</button>
		<button class="btn btn-light control-btn" (click)="toggleMuteVideo()"
			matTooltip="{{isVideoMute?'Unmute video':'Mute video'}}">
			@if(isVideoMute){
			<fa-icon [icon]="['fas', 'video-slash']"></fa-icon>
			}@else{
			<fa-icon [icon]="['fas', 'video']"></fa-icon>
			}
		</button>
		@if(localVideoStream){
		<button class="btn btn-light control-btn" (click)="openBackgroundModal()" matTooltip="Change background">
			<fa-icon [icon]="['fas', 'image']"></fa-icon>
		</button>
		}
		}
		@if(joinStatus.isJoined){
		<button class="btn btn-danger control-btn" (click)="beforeSendNotification(4);leave();" matTooltip="Leave">
			<fa-icon [icon]="['fas', 'phone']" [flip]="'horizontal'"></fa-icon>
		</button>
		}@else {
		@if (navbar.userAccess?.Chat=='Full'){
		<button class="btn btn-success control-btn" (click)="initJoinCall(true)" [disabled]="!userId || joiningCall"
			matTooltip="Video call">
			@if(userId && (!joiningCall || joiningCall!=1)){
			<fa-icon [icon]="['fas', 'video']"></fa-icon>
			}@else {
			<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
			}
		</button>
		<button class="btn btn-success control-btn" (click)="initJoinCall(false)" [disabled]="!userId || joiningCall"
			matTooltip="Audio call">
			@if(userId && (!joiningCall || joiningCall!=2)){
			<fa-icon [icon]="['fas', 'phone']" [flip]="'horizontal'"></fa-icon>
			}@else {
			<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
			}
		</button>
		}
		}
		@if (!production) {
		<button class="btn btn-danger control-btn" (click)="deleteChat()" matTooltip="Delete chat"
			style="display:none;">
			<fa-icon [icon]="['fas', 'trash']"></fa-icon>
		</button>
		}
	</div>
	@if(waitingTimeString){
	<div class="waiting-banner">
		<span class="pulse-dot"></span>
		{{ waitingTimeString }}
	</div>
	}
	<div class="input-group input-group-sm px-1 py-0">
		<input type="text" class="form-control" placeholder="Search" [formControl]="msgSearchControl" />
		<button class="btn btn-outline-dark" *ngIf="msgSearchControl.value" (click)="clearChatSearch()" type="button"
			matTooltip="Clear">
			<fa-icon [icon]="['fas', 'times']"></fa-icon>
		</button>
	</div>
	<div class="chat-section border-top border-secondary d-flex flex-column" id="chat-section-container">
		<div class="messages flex-grow-1 overflow-auto p-2" id="messages-container">
			@if (navbar.userAccess?.Chat=='Full' || navbar.userAccess?.Chat=='Readonly'){
			@for (item of messages; track $index) {
			@if (!item.is_call) {
			<div class="msg" [ngClass]="{ 'msg-me': item.from === userName, 'msg-them': item.from !== userName }">
				<small class="timeStyle">
					{{ item.from_name }}:
				</small>
				@if (item.file_url) {
				<div class="icon-container no-delete">
					<file-icon [file]="item.file_url" [isChatFile]="true"
						[candidateName]="getCandidateName()"></file-icon>
				</div>
				}
				@if (item.validURL) {
				<a [href]="item.message" target="_blank" rel="noopener noreferrer">
					{{ item.message }}
				</a>
				} @else {
				{{ item.message }}
				}
				@if (item.from === userName && item.is_read) {
				<i class="bi bi-eye-fill small float-end" matTooltip="Seen by candidate"></i>
				}
				<p class="timestamp">
					{{ item.time_string }}
				</p>
			</div>
			} @else {
			<div class="call-entry text-center fw-bold rounded-pill py-1 px-3 my-2 mx-auto d-flex align-items-center justify-content-center gap-2"
				[ngClass]="{
				'call-dialing': item?.call_status === 'dialing',
				'call-ended': item?.call_status === 'ended' || item?.call_status === 'answered' || !item?.call_status,
				'call-missed': item?.call_status === 'missed' || item?.call_status === 'timeout' || item?.call_status === 'cancelled',
				'call-rejected': item?.call_status === 'rejected'
			}">
				@if (item.message && item.message.includes('Video')) {
				<i class="bi" [ngClass]="{
					'bi-camera-video-fill': item?.call_status === 'dialing' || item?.call_status === 'ended' || item?.call_status === 'answered' || !item?.call_status,
					'bi-camera-video-off-fill': item?.call_status === 'missed' || item?.call_status === 'rejected' || item?.call_status === 'timeout' || item?.call_status === 'cancelled'
				}"></i>
				} @else {
				<i class="bi" [ngClass]="{
					'bi-telephone-outbound-fill': (item?.call_status === 'dialing' || item?.call_status === 'ended' || item?.call_status === 'answered' || !item?.call_status) && item.sender_type === 'doctor',
					'bi-telephone-inbound-fill': (item?.call_status === 'dialing' || item?.call_status === 'ended' || item?.call_status === 'answered' || !item?.call_status) && item.sender_type !== 'doctor',
					'bi-telephone-x-fill': item?.call_status === 'missed' || item?.call_status === 'rejected' || item?.call_status === 'timeout' || item?.call_status === 'cancelled'
				}"></i>
				}
				<small class="timeStyle">
					<span class="text-capitalize">
						{{ item.sender_type === 'candidate' ? 'Incoming' : 'Outgoing' }}
					</span>
					{{ item.message || 'Call' }}
					@switch (item?.call_status) {
					@case ('dialing') { <!-- (Calling...) --> }
					@case ('missed') {
					({{ item.sender_type === 'doctor' ? 'No Answer' : 'Missed' }})
					}
					@case ('timeout') { (Unanswered) }
					@case ('cancelled') { (Cancelled) }
					@case ('rejected') { (Declined) }
					@default { }
					}
					<span class="call-timestamp ms-1 fw-normal">
						• {{ item.time_string }}
					</span>
				</small>
			</div>
			}
			}
			}
		</div>
		@if (navbar.userAccess?.Chat=='Full'){
		<div class="input-group input-group-sm p-2 pt-1">
			<input type="text" class="form-control" placeholder="Type a message..." [(ngModel)]="msg"
				(keydown.enter)="sendMsg()" />
			<button class="btn btn-primary" (click)="sendMsg()" [disabled]="!msg">
				Send
			</button>
			<!-- <button class="btn btn-info" (click)="openFileMang()" matTooltip="Send file">
				<fa-icon [icon]="['fas','paperclip']"></fa-icon>
			</button> -->
			@if(caseDetails){
			<div class="text-start px-2 border bg-light">
				<app-file-upload #fileUploadComp [allowedFiles]="allowedBillFiles"
					[uploadFolder]="'chat_files/'+caseDetails?.id" (uploaded)="assignFileToSend($event)" [flag]="true"
					[show_toastr]="false">
				</app-file-upload>
			</div>
			}
			<!-- <button class="btn btn-primary" (mousedown)="startRecording()" (mouseup)="stopRecording()"
				(mouseleave)="stopRecording()" (touchstart)="startRecording()" (touchend)="stopRecording()"
				matTooltip="Voice note">
				@if(isRecording){
				<app-call-icon [size]="'10'"></app-call-icon>
				}@else{
				<fa-icon [icon]="['fas','microphone']"></fa-icon>
				}
			</button> -->
		</div>
		}
	</div>
</div>
<div class="modal fade" id="chatFileModal" role="dialog">
	<div class="modal-dialog modal-sm">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>File Upload</strong></h4>
				<!-- @if(fileUploaderLoader){
				<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
				} -->
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="text-start p-3 border rounded bg-light">
					<div class="mb-2">
						<label class="form-label small fw-bold text-secondary mb-1">
							Is Receipt
							<small class="text-danger">*</small>
						</label>
						<mat-radio-group [(ngModel)]="is_payment_receipt" (change)="isReceiptFormChanged()">
							<mat-radio-button [value]="'Yes'" [color]="'primary'">
								Yes
							</mat-radio-button>
							<mat-radio-button [value]="'No'" [color]="'primary'">
								No
							</mat-radio-button>
						</mat-radio-group>
					</div>
					@if(is_payment_receipt === 'Yes'){
					<div class="mb-3">
						<label class="form-label small fw-bold text-secondary mb-1">
							Amount
							<small class="text-danger">*</small>
						</label>
						<input type="number" class="form-control form-control-sm" [(ngModel)]="receipt_amount"
							(ngModelChange)="isReceiptFormChanged()" placeholder="Enter amount">
					</div>
					}
				</div>
				<!-- @if(caseDetails && showChatFileUploader){
				<div class="text-start p-3 border rounded bg-light mt-2">
					<app-file-upload [allowedFiles]="allowedBillFiles" [uploadFolder]="'chat_files/'+caseDetails?.id"
						(uploaded)="sendFile($event)" [flag]="true">
					</app-file-upload>
				</div>
				} -->
			</div>
			<div class="modal-footer">
				@if(showChatFileUploader && fileUrlToSend){
				<button class="btn btn-success btn-sm" (click)="sendFile(fileUrlToSend)">
					@if(fileUploaderLoader){
					<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
					}
					Send
				</button>
				}
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="backgroundModal" role="dialog">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">
					<strong>Set Background</strong>
				</h4>
				<button type="button" class="btn-close" data-bs-dismiss="modal"></button>
			</div>
			<div class="modal-body">
				<div class="row">
					<div *ngFor="let c of bgColors" class="col-sm-4 text-center mb-2">
						<div class="bg-item" [ngStyle]="{'background-color':c}"
							(click)="setBackgroundProperty(c,'color')"></div>
					</div>
					<div *ngFor="let im of bgImages" class="col-sm-4 text-center mb-2">
						<div class="bg-item" (click)="setBackgroundProperty(im,'img')">
							<img src="{{im}}" class="bg-img" />
						</div>
					</div>
					<div class="col-sm-4 text-center mb-2">
						<div class="bg-item" matTooltip="Blur" (click)="setBackgroundProperty('','blur')">
							<img src="../../../assets/img/bg-blur.jpg" class="bg-img" />
						</div>
					</div>
					<div class="col-sm-4 text-center mb-2">
						<div class="bg-item text-center" style="padding-top: 30px;" matTooltip="Original"
							(click)="setBackgroundProperty('','')">
							Original
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-sm btn-info" data-bs-dismiss="modal">Close</button>
			</div>
		</div>
	</div>
</div>